// Prototype-JS. Verhuist later naar assets/thema.js in het Shopify-thema.
// Per sectie één init-functie, zodat het straks ook opnieuw kan draaien na een
// section-render in de theme editor (shopify:section:load).

const rustigeVoorkeur = window.matchMedia("(prefers-reduced-motion: reduce)");

/* --------------------------------------------------------------------------
   Hero
   -------------------------------------------------------------------------- */

function initHero(wortel = document) {
  const hero = wortel.querySelector(".hero");
  if (!hero) return;

  zetRingLengte(hero);
  startOnthulling();
  initFeiten(hero);
  initParallax(hero);
  initLint(hero);
}

// De ring tekent zichzelf; daarvoor moet de padlengte bekend zijn.
function zetRingLengte(hero) {
  const pad = hero.querySelector(".hero__ring path");
  if (!pad) return;
  const lengte = Math.ceil(pad.getTotalLength());
  pad.style.setProperty("--ring-lengte", lengte);
}

// Eén klasse op <body> zet alle intro-animaties in gang (CSS doet de rest).
function startOnthulling() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => document.body.classList.add("is-geladen"));
  });
}

/* --------------------------------------------------------------------------
   Wegduwende bollen
   Gedeeld gedrag voor de feitjes in de hero en de betaalcirkels in de footer.

   Geen doorlopend krachtveld: de muis geeft één duwtje op het moment dat hij
   binnen bereik komt, en de veer trekt de bol meteen weer naar zijn plek.
   Blijft de muis stilstaan, dan blijft de bol dus niet weggeduwd. Pas als de
   muis weer ruim buiten bereik is, kan er opnieuw geduwd worden.

   De uitwijking gaat naar --nx/--ny; de CSS zet die in `translate`, zodat ze
   niet vechten met een `transform` die ergens anders vandaan komt.
   -------------------------------------------------------------------------- */

function initDuwBollen(vlak, kiezer, opties = {}) {
  if (rustigeVoorkeur.matches) return;

  const bollen = [...vlak.querySelectorAll(kiezer)];
  if (!bollen.length) return;

  const VEER = 0.12; // hoe hard hij terug wil naar zijn plek
  const DEMPING = 0.86; // onder 1 schiet hij door: dat geeft de bounce
  const OPNIEUW = 1.35; // hoeveel verder de muis moet zijn voor een nieuwe zet
  // Het bereik schaalt mee met de bolgrootte: op een smal scherm (of in de
  // smallere editor-preview) zou een vaste pixelmaat de rij al bij verre
  // muisbewegingen laten stuiteren.
  const bereikFactor = opties.bereikFactor ?? 1.35;
  const impuls = opties.impuls ?? 13; // goed voor ~27px uitwijking

  const staat = bollen.map(() => ({ x: 0, y: 0, vx: 0, vy: 0, geraakt: false }));
  let muis = null;
  let actief = false;

  const stap = () => {
    // Sectie door de editor vervangen? Dan is deze lus klaar.
    if (!vlak.isConnected) {
      actief = false;
      return;
    }

    const bereik = (bollen[0].offsetWidth || 110) * bereikFactor;

    // Eerst alles meten, daarna pas schrijven — anders forceert elke
    // uitlezing een nieuwe layout.
    const metingen = bollen.map((el, i) => {
      if (!muis) return null;
      const r = el.getBoundingClientRect();
      // De huidige uitwijking eraf halen geeft de rustpositie terug
      const vx = r.left + r.width / 2 - staat[i].x - muis.x;
      const vy = r.top + r.height / 2 - staat[i].y - muis.y;
      return { vx, vy, afstand: Math.hypot(vx, vy) };
    });

    let beweegt = false;

    bollen.forEach((el, i) => {
      const s = staat[i];
      const m = metingen[i];

      if (!m) {
        s.geraakt = false;
      } else if (!s.geraakt && m.afstand < bereik && m.afstand > 0.001) {
        s.vx += (m.vx / m.afstand) * impuls;
        s.vy += (m.vy / m.afstand) * impuls;
        s.geraakt = true;
      } else if (s.geraakt && m.afstand > bereik * OPNIEUW) {
        s.geraakt = false;
      }

      // De veer mikt altijd op de rustplek, nooit op een uitgeweken doel
      s.vx = (s.vx - s.x * VEER) * DEMPING;
      s.vy = (s.vy - s.y * VEER) * DEMPING;
      s.x += s.vx;
      s.y += s.vy;

      if (Math.abs(s.x) + Math.abs(s.y) + Math.abs(s.vx) + Math.abs(s.vy) > 0.05) {
        beweegt = true;
      }

      el.style.setProperty("--nx", s.x.toFixed(2) + "px");
      el.style.setProperty("--ny", s.y.toFixed(2) + "px");
    });

    // Niets in beweging en geen muis in de buurt: slapen tot de volgende
    // pointerbeweging. Scheelt werk, en in de editor kan een lus zo nooit
    // verweesd blijven doordraaien.
    if (!beweegt && !muis) {
      actief = false;
      return;
    }

    requestAnimationFrame(stap);
  };

  const wek = () => {
    if (actief) return;
    actief = true;
    requestAnimationFrame(stap);
  };

  vlak.addEventListener("pointermove", (e) => {
    muis = { x: e.clientX, y: e.clientY };
    wek();
  });
  vlak.addEventListener("pointerleave", () => {
    muis = null;
    wek();
  });

  wek();
}

// Feitjes-bubbels: posities komen uit de CSS (--x/--y in kolomprocenten),
// hier zit alleen het wegduw-gedrag.
function initFeiten(hero) {
  initDuwBollen(hero, ".feit");
}

// Product schuift en kantelt licht mee met de scroll.
// De referentie speelt hier een image-sequence op canvas af; dat vervangen we
// door een parallax tot er een echte beeldsequentie is.
function initParallax(hero) {
  if (rustigeVoorkeur.matches) return;

  const doel = hero.querySelector("[data-parallax]");
  if (!doel) return;

  let bezig = false;

  const teken = () => {
    bezig = false;
    if (!hero.isConnected) return;
    const rect = hero.getBoundingClientRect();
    const totaal = rect.height + window.innerHeight;
    // 0 = hero komt net in beeld, 1 = hero net uit beeld
    const voortgang = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / totaal));
    const verschoven = voortgang - 0.5;

    // Alleen transform; de vaste kanteling zit in de CSS op `rotate` en het
    // zweven op `translate`, zodat die drie elkaar niet overschrijven.
    doel.style.transform =
      `translate3d(0, ${verschoven * -60}px, 0) ` +
      `rotate(${verschoven * 6}deg) ` +
      `scale(${1 + Math.abs(verschoven) * 0.03})`;
  };

  const opScroll = () => {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(teken);
  };

  window.addEventListener("scroll", opScroll, { passive: true });
  window.addEventListener("resize", opScroll);
  teken();
}

// De lint-tekst is aan de scroll gekoppeld, zoals in de referentie: hij
// beweegt alleen mee terwijl je scrolt en staat stil zodra jij stilstaat.
function initLint(hero) {
  const pad = hero.querySelector("[data-lint-tekst]");
  if (!pad || rustigeVoorkeur.matches) return;
  if (pad.dataset.lintInit) return;
  pad.dataset.lintInit = "1";

  const BASIS = -30; // startOffset in rust (bovenaan de pagina)
  const FACTOR = 0.022; // procent padlengte per gescrolde pixel
  let bezig = false;

  const teken = () => {
    bezig = false;
    if (!pad.isConnected) return;
    pad.setAttribute("startOffset", BASIS - window.scrollY * FACTOR + "%");
  };

  const opScroll = () => {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(teken);
  };

  window.addEventListener("scroll", opScroll, { passive: true });
  teken();
}

/* --------------------------------------------------------------------------
   Betaalmethoden
   De cirkels vliegen in zodra de sectie in beeld komt (CSS doet de animatie),
   en volgen daarna de muis met naloop: elke cirkel heeft een eigen traagheid,
   waardoor de rij als een sliert achter de cursor aan beweegt.
   -------------------------------------------------------------------------- */

// Welke betaal-secties hun invlieg al hebben gespeeld. De editor rendert
// een sectie bij elke instelling-wijziging opnieuw; de animatie hoort dan
// niet telkens te herspelen (en al helemaal niet op opacity 0 te blijven
// hangen als de sectie buiten beeld herlaadt). Live speelt hij gewoon één
// keer, precies zoals nu.
const betaalGespeeld = new Set();

function initBetaal(wortel = document) {
  const sectie = wortel.querySelector("[data-betaal]");
  if (!sectie) return;

  const sleutel = sectie.closest(".shopify-section")?.id ?? "betaal";

  // Binnenkomst: één keer echt animeren, daarna direct de eindstand
  if (betaalGespeeld.has(sleutel)) {
    sectie.classList.add("is-zichtbaar");
  } else {
    const kijker = new IntersectionObserver(
      (items) => {
        items.forEach((item) => {
          if (!item.isIntersecting) return;
          betaalGespeeld.add(sleutel);
          sectie.classList.add("is-zichtbaar");
          kijker.disconnect();
        });
      },
      { threshold: 0.15 }
    );
    kijker.observe(sectie);
  }

  /* --- De boog opnieuw uitrekenen --------------------------------------
     Liquid zet de hoogtes voor de betaalmethodes die Shopify zelf doorgeeft,
     maar in de editor kun je er eigen logo's bij zetten. Die tellen hier mee,
     zodat de rij een gelijkmatige vallei blijft: de buitenste cirkels het
     hoogst, het midden het laagst. Zelfde formule als in de sectie. */
  const rij = sectie.querySelector("[data-betaalrij]");
  const items = rij ? [...rij.querySelectorAll(".betaal__item")] : [];
  if (items.length > 1) {
    const midden = (items.length - 1) / 2;
    items.forEach((item, i) => {
      const stap = Math.min(3, Math.abs(i - midden));
      const hoog = stap * (3.4375 + 0.3125 * stap);
      item.style.setProperty("--i", String(i));
      item.style.setProperty("--hoog", hoog.toFixed(3) + "em");
    });

    /* En de breedte van de rij, waarmee de stylesheet de cirkels krimpt als
       het er veel worden. Zie --rijbreed in betaalmethoden.css. */
    sectie.style.setProperty(
      "--rijbreed",
      (items.length * 14.3125 - 1.25).toFixed(4)
    );
  }

  /* De stylesheet schat de beschikbare breedte met vw, maar die telt de
     scrollbalk mee en weet niets van de padding om de voettekst heen. Hier
     meten we de sectie zelf op, zodat de buitenste cirkels precies binnen de
     rand blijven in plaats van er half achter te verdwijnen. */
  const meetRuimte = () => {
    const breed = sectie.clientWidth;
    if (!breed) return;
    const nu = sectie.style.getPropertyValue("--rijruimte");
    if (nu === breed + "px") return;
    sectie.style.setProperty("--rijruimte", breed + "px");
  };
  meetRuimte();
  /* Allebei: de waarnemer merkt ook veranderingen die niets met het venster
     te maken hebben, en de luisteraar werkt ook als de pagina op de
     achtergrond staat en er geen beeld getekend wordt. */
  if ("ResizeObserver" in window) {
    new ResizeObserver(meetRuimte).observe(sectie);
  }
  window.addEventListener("resize", meetRuimte, { passive: true });

  // Zelfde wegduw-gedrag als de feitjes in de hero; factor 0.91 komt op
  // desktop overeen met het oude vaste bereik van 190px.
  initDuwBollen(sectie, ".betaal__item", { bereikFactor: 0.91, impuls: 15 });
}

/* --------------------------------------------------------------------------
   Collectie-carrousel
   Eén product tegelijk. De pijlen wisselen; tekst en beeld faden even weg en
   komen met de nieuwe inhoud terug. De producten staan nu in deze lijst;
   in Shopify komt dit uit de gekozen collectie.
   -------------------------------------------------------------------------- */

const COLLECTIE = [
  {
    label: "Keramiek",
    naam: "Keramische<br />olla",
    prijs: "€ 24,95",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
  {
    label: "Keramiek",
    naam: "Vaas<br />rond",
    prijs: "€ 39,95",
    beeld: "img/olla-groen.png",
    voorraad: false,
  },
  {
    label: "Sfeer",
    naam: "Kaarsen<br />houder",
    prijs: "€ 18,50",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
  {
    label: "Textiel",
    naam: "Linnen<br />kussenhoes",
    prijs: "€ 34,95",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
  {
    label: "Klein",
    naam: "Schaal<br />klein",
    prijs: "€ 22,50",
    beeld: "img/olla-groen.png",
    voorraad: false,
  },
];

function initCarrousel(wortel = document) {
  const vlak = wortel.querySelector("[data-carrousel]");
  if (!vlak) return;

  const veld = (naam) => vlak.querySelector(`[data-veld="${naam}"]`);
  const knop = veld("knop");
  let i = 0;
  let bezig = false;

  const toon = (index) => {
    const p = COLLECTIE[index];
    veld("label").textContent = p.label;
    veld("naam").innerHTML = p.naam;
    veld("prijs").textContent = p.prijs;
    veld("beeld").src = p.beeld;

    veld("prijs").classList.toggle("is-uitverkocht", !p.voorraad);
    vlak.classList.toggle("is-uitverkocht", !p.voorraad);

    veld("knoptekst").textContent = p.voorraad ? "Bestel nu" : "Bekijken";
    knop.setAttribute("aria-disabled", String(!p.voorraad));
  };

  const wissel = (richting) => {
    if (bezig) return;
    bezig = true;

    // Even wegfaden, dan pas de inhoud verwisselen
    vlak.classList.add("is-wisselt");
    setTimeout(() => {
      i = (i + richting + COLLECTIE.length) % COLLECTIE.length;
      toon(i);
      vlak.classList.remove("is-wisselt");
      bezig = false;
    }, 220);
  };

  vlak.querySelector("[data-vorige]").addEventListener("click", () => wissel(-1));
  vlak.querySelector("[data-volgende]").addEventListener("click", () => wissel(1));

  toon(0);
}

/* --------------------------------------------------------------------------
   Kaartraster
   Tweede weergave van dezelfde COLLECTIE: alle producten naast elkaar. Het
   sjabloon staat als <template> in de HTML en wordt hier per product
   gekloond, zodat de opmaak op één plek staat — precies zoals de Liquid-lus
   het straks doet.
   -------------------------------------------------------------------------- */

function initKaartraster(wortel = document) {
  const raster = wortel.querySelector("[data-kaartraster]");
  if (!raster) return;

  const sjabloon = raster.querySelector("[data-kaart-sjabloon]");
  if (!sjabloon) return;

  // Bij een herstart (theme editor) eerst de vorige ronde weg
  raster.querySelectorAll(".productkaart").forEach((k) => k.remove());

  const plat = (html) => html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

  COLLECTIE.forEach((p) => {
    const kaart = sjabloon.content.firstElementChild.cloneNode(true);
    const veld = (naam) => kaart.querySelector(`[data-veld="${naam}"]`);
    const naam = plat(p.naam);

    veld("beeld").src = p.beeld;
    veld("beeld").alt = naam;
    veld("label").textContent = p.label;
    veld("naam").innerHTML = p.naam;
    veld("prijs").textContent = p.prijs;

    const link = veld("link");
    link.setAttribute(
      "aria-label",
      p.voorraad ? `Bekijk ${naam}` : `${naam} — uitverkocht`
    );
    link.setAttribute("aria-disabled", String(!p.voorraad));

    kaart.classList.toggle("is-uitverkocht", !p.voorraad);
    raster.append(kaart);
  });

  // De kaarten bestaan pas nu, dus hun hover moet hier gekoppeld worden
  initPilHover(raster);
}

/* --------------------------------------------------------------------------
   Actie met aftelklok
   De klok telt af naar de datum in data-eind; loopt die af, dan verdwijnt de
   klok en komt er een regel voor in de plaats. De kaart rechts wisselt met de
   bolletjes en wordt gekloond uit het sjabloon van het kaartraster: één
   productkaart voor de hele site.

   In Shopify wordt data-eind een instelling en komen de producten uit de
   gekozen collectie.
   -------------------------------------------------------------------------- */

const ACTIES = [
  {
    label: "Keramiek",
    naam: "Keramische<br />olla",
    prijs: "€ 19,95",
    vanaf: "€ 24,95",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
  {
    label: "Sfeer",
    naam: "Kaarsen<br />houder",
    prijs: "€ 14,50",
    vanaf: "€ 18,50",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
  {
    label: "Textiel",
    naam: "Linnen<br />kussenhoes",
    prijs: "€ 27,95",
    vanaf: "€ 34,95",
    beeld: "img/olla-groen.png",
    voorraad: true,
  },
];

function initActie(wortel = document) {
  const sectie = wortel.querySelector(".actie") ?? document.querySelector(".actie");
  if (!sectie) return;

  initAftellen(sectie);

  const vak = sectie.querySelector("[data-actie-product]");
  const bolletjes = sectie.querySelector("[data-actie-bolletjes]");
  const sjabloon = document.querySelector("[data-kaart-sjabloon]");
  if (!vak || !bolletjes || !sjabloon) return;

  let i = 0;
  let bezig = false;

  const teken = () => {
    const a = ACTIES[i];
    const kaart = sjabloon.content.firstElementChild.cloneNode(true);
    const veld = (naam) => kaart.querySelector(`[data-veld="${naam}"]`);
    const plat = a.naam.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

    veld("beeld").src = a.beeld;
    veld("beeld").alt = plat;
    veld("label").textContent = a.label;
    veld("naam").innerHTML = a.naam;
    veld("prijs").textContent = a.prijs;

    const vanaf = veld("vanaf");
    vanaf.hidden = !a.vanaf;
    if (a.vanaf) vanaf.textContent = a.vanaf;

    veld("link").setAttribute("aria-label", `Bekijk ${plat}`);

    vak.replaceChildren(kaart);
    initPilHover(vak);

    [...bolletjes.children].forEach((bol, index) => {
      bol.classList.toggle("is-actief", index === i);
      bol.setAttribute("aria-current", String(index === i));
    });
  };

  // Bolletjes één keer opbouwen; daarna wisselen ze alleen van staat.
  // (Vanaf schoon: een herinit door de editor mag ze niet verdubbelen.)
  bolletjes.replaceChildren();
  ACTIES.forEach((a, index) => {
    const bol = document.createElement("button");
    bol.type = "button";
    bol.className = "actie__bol";
    bol.setAttribute("aria-label", `Toon aanbieding ${index + 1}`);
    bol.addEventListener("click", () => wissel(index));
    bolletjes.append(bol);
  });

  const wissel = (naar) => {
    if (bezig || naar === i) return;
    bezig = true;
    vak.classList.add("is-wisselt");

    setTimeout(() => {
      i = naar;
      teken();
      vak.classList.remove("is-wisselt");
      bezig = false;
    }, 220);
  };

  teken();
}

function initAftellen(sectie) {
  const klok = sectie.querySelector("[data-aftellen]");
  if (!klok) return;

  const eind = new Date(klok.dataset.eind).getTime();
  if (Number.isNaN(eind)) return;

  const afgelopen = sectie.querySelector("[data-afgelopen]");
  const veld = (naam) => klok.querySelector(`[data-${naam}]`);
  const twee = (getal) => String(Math.floor(getal)).padStart(2, "0");
  let tikTimer = null;

  const tik = () => {
    const over = eind - Date.now();

    if (over <= 0) {
      klok.hidden = true;
      if (afgelopen) afgelopen.hidden = false;
      clearInterval(loop);
      return;
    }

    const seconden = over / 1000;
    veld("dagen").textContent = twee(seconden / 86400);
    veld("uren").textContent = twee((seconden / 3600) % 24);
    veld("minuten").textContent = twee((seconden / 60) % 60);
    veld("seconden").textContent = twee(seconden % 60);

    // Kort duwtje op de seconden, zodat je ziet dat hij loopt
    klok.classList.add("is-tik");
    clearTimeout(tikTimer);
    tikTimer = setTimeout(() => klok.classList.remove("is-tik"), 90);
  };

  // Herinit (editor) mag geen tweede klok laten tikken
  if (klok._aftelLoop) clearInterval(klok._aftelLoop);
  const loop = setInterval(tik, 1000);
  klok._aftelLoop = loop;
  tik();
}

/* --------------------------------------------------------------------------
   Pagina opzij
   Gedeeld door het menu en de winkelwagen: de pagina wordt een venster dat
   vastzit op het scherm (met de laag erbinnen op de scrollstand), zodat een
   paneel zich kan onthullen door de pagina weg te schuiven. Welke kant hij
   op gaat bepaalt de CSS via data-modus.
   -------------------------------------------------------------------------- */

const paginaOpzij = {
  scrollY: 0,

  vast(modus) {
    const pagina = document.querySelector("[data-pagina]");
    if (!pagina) return false;

    this.scrollY = window.scrollY;
    pagina.style.setProperty("--scroll-y", `${this.scrollY}px`);
    pagina.classList.remove("is-sluitend");
    if (modus) pagina.dataset.modus = modus;

    const binnen = pagina.querySelector("[data-pagina-binnen]") ?? pagina;
    if (binnen !== pagina) binnen.inert = true;
    else [...pagina.children].forEach((kind) => (kind.inert = true));
    return true;
  },

  los() {
    const pagina = document.querySelector("[data-pagina]");
    if (!pagina) return;

    // Het venster blijft staan tot de terugklap-animatie klaar is; anders
    // springt de vastgezette kop-balk naar de bovenkant van het document.
    pagina.classList.add("is-sluitend");

    const binnen = pagina.querySelector("[data-pagina-binnen]") ?? pagina;
    if (binnen !== pagina) binnen.inert = false;
    else [...pagina.children].forEach((kind) => (kind.inert = false));

    const losmaken = () => {
      pagina.classList.remove("is-sluitend");
      pagina.style.removeProperty("--scroll-y");
      delete pagina.dataset.modus;
      if (!this.scrollY) return;

      // Zonder de smooth-scroll uit basis.css, anders zie je de pagina van
      // bovenaf terugkruipen.
      const wortel = document.documentElement;
      const gedrag = wortel.style.scrollBehavior;
      wortel.style.scrollBehavior = "auto";
      window.scrollTo(0, this.scrollY);
      wortel.style.scrollBehavior = gedrag;
    };

    const klaar = (e) => {
      if (e.target !== pagina || e.propertyName !== "transform") return;
      pagina.removeEventListener("transitionend", klaar);
      losmaken();
    };

    pagina.addEventListener("transitionend", klaar);
    // Vangnet: geen transitie (reduced motion) of een gemiste event
    setTimeout(() => {
      pagina.removeEventListener("transitionend", klaar);
      if (pagina.classList.contains("is-sluitend")) losmaken();
    }, 900);
  },
};

/* --------------------------------------------------------------------------
   Winkelwagen
   Eén lijst met artikelen plus een lade die zichzelf hertekent. Bedragen
   staan in centen, net als in Shopify, zodat er niets afrondt onderweg.

   In Shopify vervangt de cart-API deze lijst: toevoegen wordt /cart/add.js,
   het aantal /cart/change.js en teken() wordt gevoed door /cart.js. De rest
   van de opbouw hieronder kan dan blijven staan.
   -------------------------------------------------------------------------- */

const GRATIS_VANAF = 5000; // centen; hierboven geen verzendkosten

// In het thema zet layout/theme.liquid deze vlag: dan praat de wagen met de
// echte cart-API en zoekt de zoeklaag in de echte winkel. Zonder vlag (het
// prototype) blijft alles lokaal werken zoals het was.
const OP_SHOPIFY = typeof window !== "undefined" && Boolean(window.THEMA_SHOPIFY);

const geld = (centen) => "€ " + (centen / 100).toFixed(2).replace(".", ",");

const wagen = {
  artikelen: [],
  opener: null,

  get stuks() {
    return this.artikelen.reduce((som, a) => som + a.aantal, 0);
  },

  get totaal() {
    return this.artikelen.reduce((som, a) => som + a.prijs * a.aantal, 0);
  },

  // Shopify: de winkelwagen van de winkel is de waarheid; elke wijziging
  // gaat langs de cart-API en daarna tekenen we de lijst opnieuw.
  async haalOp() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      this.artikelen = cart.items.map((r) => ({
        id: r.key,
        naam: r.product_title,
        variant: r.variant_title && r.variant_title !== "Default Title" ? r.variant_title : "",
        prijs: r.final_price ?? r.price,
        beeld: r.image || "",
        aantal: r.quantity,
      }));
      this.teken();
    } catch {
      /* geen verbinding: de lijst blijft zoals hij was */
    }
  },

  voegToe(artikel) {
    if (OP_SHOPIFY) {
      if (!artikel.variantId) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: artikel.variantId, quantity: artikel.aantal || 1 }] }),
      }).then(async (res) => {
        // Uitverkocht of niet leverbaar: de winkel bepaalt; wij laten de
        // reden zien in plaats van stilletjes niets te doen.
        if (!res.ok) {
          const fout = await res.json().catch(() => null);
          this.melding = (fout && (fout.description || fout.message)) ||
            "Dit product is nu niet te bestellen.";
        }
        return this.haalOp();
      });
      return;
    }

    const bestaand = this.artikelen.find((a) => a.id === artikel.id);
    if (bestaand) bestaand.aantal += artikel.aantal;
    else this.artikelen.push({ ...artikel });
    this.teken();
  },

  // Op nul verdwijnt de regel en wordt de lijst opnieuw getekend; bij een
  // gewone wijziging blijft de bestaande regel staan en werken we alleen de
  // cijfers bij. Anders vervangen we de knop waar je net op klikte, en
  // springt de focus naar het niets.
  zetAantal(id, aantal) {
    if (OP_SHOPIFY) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: String(id), quantity: Math.max(0, aantal) }),
      }).then(() => this.haalOp());
      return;
    }

    const artikel = this.artikelen.find((a) => a.id === id);
    if (!artikel) return;

    if (aantal <= 0) {
      this.artikelen.splice(this.artikelen.indexOf(artikel), 1);
      this.teken();
      return;
    }

    artikel.aantal = Math.min(aantal, 99);
    this.werkRegelBij(artikel);
    this.werkTotalenBij();
  },

  werkRegelBij(artikel) {
    const regel = document.querySelector(`[data-regel-id="${artikel.id}"]`);
    if (!regel) return;

    regel.querySelector("[data-veld='aantal']").textContent = artikel.aantal;
    regel.querySelector("[data-veld='prijs']").textContent = geld(
      artikel.prijs * artikel.aantal
    );
    regel
      .querySelector("[data-min]")
      .setAttribute(
        "aria-label",
        artikel.aantal === 1 ? `${artikel.naam} verwijderen` : "Eén minder"
      );
  },

  open(opener) {
    const lade = document.querySelector("[data-lade]");
    if (!lade) return;

    this.opener = opener ?? null;
    lade.classList.add("is-open");
    lade.inert = false;
    lade.setAttribute("aria-hidden", "false");

    // Op pagina's met een pagina-laag (magazine) schuift de pagina opzij en
    // is er geen donkere waas; elders klapt de lade als vanouds overheen.
    if (!paginaOpzij.vast("lade")) {
      document.querySelector("[data-waas]")?.classList.add("is-open");
    }

    document.body.classList.add("lade-open");
    setTimeout(() => lade.querySelector("[data-lade-sluit]")?.focus(), 300);
  },

  sluit() {
    const lade = document.querySelector("[data-lade]");
    if (!lade || !lade.classList.contains("is-open")) return;

    lade.classList.remove("is-open");
    lade.inert = true;
    lade.setAttribute("aria-hidden", "true");
    document.querySelector("[data-waas]")?.classList.remove("is-open");
    document.body.classList.remove("lade-open");
    paginaOpzij.los();
    this.opener = null;
  },

  teken() {
    const lijst = document.querySelector("[data-lade-lijst]");
    const sjabloon = lijst?.querySelector("[data-regel-sjabloon]");
    if (!lijst || !sjabloon) return;

    lijst.querySelectorAll(".wagenregel").forEach((r) => r.remove());
    lijst.querySelector(".lade__melding")?.remove();

    if (this.melding) {
      const melding = document.createElement("p");
      melding.className = "lade__melding";
      melding.textContent = this.melding;
      lijst.prepend(melding);
      this.melding = null;
    }

    this.artikelen.forEach((a) => {
      const regel = sjabloon.content.firstElementChild.cloneNode(true);
      const veld = (naam) => regel.querySelector(`[data-veld="${naam}"]`);

      regel.dataset.regelId = a.id;
      if (a.beeld) veld("beeld").src = a.beeld;
      veld("beeld").alt = a.naam;
      veld("naam").textContent = a.naam;
      veld("variant").textContent = a.variant;
      veld("aantal").textContent = a.aantal;
      veld("prijs").textContent = geld(a.prijs * a.aantal);

      // Op 1 stuk wordt de min-knop een verwijderknop
      const min = regel.querySelector("[data-min]");
      min.setAttribute(
        "aria-label",
        a.aantal === 1 ? `${a.naam} verwijderen` : "Eén minder"
      );

      lijst.append(regel);
    });

    lijst
      .querySelector("[data-lade-leeg]")
      ?.toggleAttribute("hidden", this.artikelen.length > 0);

    this.werkTotalenBij();
  },

  werkTotalenBij() {
    const leeg = this.artikelen.length === 0;

    const telling = document.querySelector("[data-lade-telling]");
    if (telling) telling.textContent = `(${this.stuks})`;

    const badge = document.querySelector("[data-wagen-telling]");
    if (badge) {
      badge.textContent = this.stuks;
      badge.classList.toggle("is-gevuld", this.stuks > 0);
    }

    const knop = document.querySelector("[data-wagen-knop]");
    knop?.setAttribute(
      "aria-label",
      leeg ? "Winkelwagen openen" : `Winkelwagen openen, ${this.stuks} artikelen`
    );

    const subtotaal = document.querySelector("[data-subtotaal]");
    if (subtotaal) subtotaal.textContent = geld(this.totaal);

    const afrekenen = document.querySelector("[data-afrekenen]");
    if (afrekenen) {
      afrekenen.disabled = leeg;
      afrekenen.style.opacity = leeg ? "0.4" : "";
    }

    // Voortgang naar gratis verzending
    const tekort = Math.max(0, GRATIS_VANAF - this.totaal);
    const balk = document.querySelector("[data-balk]");
    if (balk) balk.style.setProperty("--deel", Math.min(1, this.totaal / GRATIS_VANAF));

    const melding = document.querySelector("[data-verzending]");
    if (melding) {
      melding.textContent = tekort
        ? `Nog ${geld(tekort)} tot gratis verzending`
        : "Je verzending is gratis";
    }
  },
};

function initWinkelwagen(wortel = document) {
  const lade = wortel.querySelector("[data-lade]") ?? document.querySelector("[data-lade]");
  if (!lade || lade.dataset.ladeInit) return;
  lade.dataset.ladeInit = "1";

  // Via delegatie: de knop zit in de kop-balk-sectie en kan door de editor
  // opnieuw gerenderd worden; een listener op document overleeft dat.
  document.addEventListener("click", (e) => {
    const knop = e.target.closest("[data-wagen-knop]");
    if (knop) wagen.open(knop);
  });

  lade.querySelector("[data-lade-sluit]")?.addEventListener("click", () => wagen.sluit());
  document.querySelector("[data-waas]")?.addEventListener("click", () => wagen.sluit());

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && lade.classList.contains("is-open")) wagen.sluit();
  });

  // Schuift de pagina opzij (magazine), dan is die weggeschoven pagina zelf
  // ook een sluitknop — behalve de wagenknop erin, die opent hem juist.
  document.querySelector("[data-pagina]")?.addEventListener("click", (e) => {
    if (!lade.classList.contains("is-open")) return;
    if (e.target.closest("[data-wagen-knop]")) return;
    e.preventDefault();
    wagen.sluit();
  });

  // De regels worden telkens opnieuw getekend, dus één luisteraar op de lijst
  lade.querySelector("[data-lade-lijst]")?.addEventListener("click", (e) => {
    const regel = e.target.closest(".wagenregel");
    if (!regel) return;

    const id = regel.dataset.regelId;
    const artikel = wagen.artikelen.find((a) => String(a.id) === id);
    if (!artikel) return;

    if (e.target.closest("[data-min]")) wagen.zetAantal(artikel.id, artikel.aantal - 1);
    if (e.target.closest("[data-plus]")) wagen.zetAantal(artikel.id, artikel.aantal + 1);
    if (e.target.closest("[data-verwijder]")) wagen.zetAantal(artikel.id, 0);
  });

  document.querySelector("[data-afrekenen]")?.addEventListener("click", () => {
    if (OP_SHOPIFY) window.location.href = "/checkout";
  });

  if (OP_SHOPIFY) wagen.haalOp();
  else wagen.teken();
}

/* --------------------------------------------------------------------------
   Zoeken
   Zelfde laag-mechaniek als de winkelwagen: op pagina's met een pagina-laag
   schuift de pagina opzij, elders klapt het paneel over de pagina heen.

   Er wordt gezocht in producten én artikelen door elkaar — dat is het
   magazine-idee: alles telt even zwaar, de prijs is het enige verschil.
   In Shopify voedt de predictive search API deze lijst.
   -------------------------------------------------------------------------- */

const ZOEKGEGEVENS = [
  { soort: "product", naam: "Keramische olla", sub: "Groen glazuur", trefwoorden: "olla water geven planten keramiek gieten", id: 81001, prijs: 2495, beeld: "img/olla-groen.png" },
  { soort: "product", naam: "Linnen kussenhoes", sub: "Linnen, zand", trefwoorden: "kussen hoes linnen interieur zand", id: 81002, prijs: 3495, beeld: "img/olla-groen.png" },
  { soort: "product", naam: "Plantenvoeding", sub: "250 ml, universeel", trefwoorden: "voeding groei verzorging planten", id: 45001, prijs: 995, beeld: "img/olla-groen.png" },
  { soort: "product", naam: "Schaal, handgedraaid", sub: "Uit de eerste stook", trefwoorden: "schaal keramiek handgedraaid oven", id: 81003, prijs: 5900, beeld: "img/olla-groen.png" },
  { soort: "artikel", naam: "Vijftig ollas, één oven", sub: "Uit deze editie", trefwoorden: "olla oven keramiek maken atelier", link: "magazine.html#inhoud" },
  { soort: "artikel", naam: "Zes planten die vergeten willen worden", sub: "Uit deze editie", trefwoorden: "planten verzorging vergeten droogte", link: "magazine.html#inhoud" },
  { soort: "artikel", naam: "Bij Anouk in de studio, tussen de ovens", sub: "Het interview", trefwoorden: "interview anouk studio ovens", link: "magazine.html#interview" },
  { soort: "artikel", naam: "Waarom je vensterbank te warm is", sub: "Uit deze editie", trefwoorden: "vensterbank warm licht planten", link: "magazine.html#inhoud" },
  { soort: "artikel", naam: "Eerdere edities", sub: "Alles teruglezen", trefwoorden: "editie archief teruglezen koele zomer", link: "magazine.html#edities" },
];

const ZOEKTIPS = ["Olla", "Planten", "Linnen", "Interview"];
const ZOEKTIPS_SHOPIFY = ["Olla", "Serum", "Pot", "Planten"];

// Predictive search van de winkel: producten, artikelen en pagina's door
// elkaar — passend bij het magazine-idee. Productprijzen komen als tekst
// binnen ("19.90"); wij rekenen ze naar centen voor geld().
const zoekOpShopify = async (vraag) => {
  const url =
    "/search/suggest.json?q=" +
    encodeURIComponent(vraag) +
    "&resources[type]=product,article,page&resources[limit]=8";
  const res = await fetch(url);
  const data = await res.json();
  const r = data.resources.results;

  const producten = (r.products || []).map((p) => ({
    soort: "product",
    naam: p.title,
    sub: p.vendor || "",
    prijs: Math.round(parseFloat(p.price) * 100) || 0,
    beeld: (p.featured_image && p.featured_image.url) || p.image || "",
    link: p.url,
  }));
  const stukken = [...(r.articles || []), ...(r.pages || [])].map((a) => ({
    soort: "artikel",
    naam: a.title,
    sub: "",
    link: a.url,
  }));
  return [...producten, ...stukken];
};

const zoeklaag = {
  open(opener) {
    const laag = document.querySelector("[data-zoeklaag]");
    if (!laag) return;

    this.opener = opener ?? null;
    laag.classList.add("is-open");
    laag.inert = false;
    laag.setAttribute("aria-hidden", "false");

    if (!paginaOpzij.vast("lade")) {
      document.querySelector("[data-waas]")?.classList.add("is-open");
    }

    document.body.classList.add("lade-open");
    setTimeout(() => laag.querySelector("[data-zoek-invoer]")?.focus(), 350);
  },

  sluit() {
    const laag = document.querySelector("[data-zoeklaag]");
    if (!laag || !laag.classList.contains("is-open")) return;

    laag.classList.remove("is-open");
    laag.inert = true;
    laag.setAttribute("aria-hidden", "true");
    document.querySelector("[data-waas]")?.classList.remove("is-open");
    document.body.classList.remove("lade-open");
    paginaOpzij.los();
    this.opener = null;
  },
};

function initZoeken(wortel = document) {
  const laag = document.querySelector("[data-zoeklaag]");
  if (!laag || laag.dataset.zoekInit) return;
  laag.dataset.zoekInit = "1";

  const invoer = laag.querySelector("[data-zoek-invoer]");
  const lijst = laag.querySelector("[data-zoek-lijst]");

  const kaart = (item) => {
    if (item.soort === "product") {
      const binnen = `
          ${item.beeld ? `<span class="zoekkaart__beeld"><img src="${item.beeld}" alt="" /></span>` : ""}
          <span class="zoekkaart__inhoud">
            <span class="zoekkaart__soort">Product</span>
            <span class="zoekkaart__naam">${item.naam}</span>
            <span class="zoekkaart__sub">${item.sub}</span>
          </span>
          <span class="zoekkaart__prijs">${geld(item.prijs)}</span>`;
      // Met een link (Shopify) gaat de kaart naar de productpagina; in het
      // prototype legt de prijs-pil hem direct in de wagen.
      if (item.link) {
        return `<a class="zoekkaart" href="${item.link}">${binnen}</a>`;
      }
      return `<button class="zoekkaart" type="button" data-zoek-koop="${item.id}">${binnen}</button>`;
    }
    return `
      <a class="zoekkaart" href="${item.link}">
        <span class="zoekkaart__inhoud">
          <span class="zoekkaart__soort">Artikel</span>
          <span class="zoekkaart__naam">${item.naam}</span>
          <span class="zoekkaart__sub">${item.sub}</span>
        </span>
        <svg class="zoekkaart__pijl" aria-hidden="true"><use href="#ic-pijl" /></svg>
      </a>`;
  };

  const teken = async () => {
    const vraag = invoer.value.trim();

    if (!vraag) {
      const tips = OP_SHOPIFY ? ZOEKTIPS_SHOPIFY : ZOEKTIPS;
      lijst.innerHTML = `
        <div class="zoeklaag__start">
          <p class="zoeklaag__kopje">Veelgezocht</p>
          <div class="zoeklaag__tips">
            ${tips.map((t) => `<button class="zoeklaag__tip" type="button" data-zoek-tip>${t}</button>`).join("")}
          </div>
        </div>`;
      return;
    }

    let treffers;
    if (OP_SHOPIFY) {
      try {
        treffers = await zoekOpShopify(vraag);
      } catch {
        treffers = [];
      }
      // Ondertussen doorgetikt? Dan is dit antwoord verouderd.
      if (invoer.value.trim() !== vraag) return;
    } else {
      const zoek = vraag.toLowerCase();
      treffers = ZOEKGEGEVENS.filter((i) =>
        `${i.naam} ${i.sub} ${i.trefwoorden}`.toLowerCase().includes(zoek)
      );
    }

    if (!treffers.length) {
      // Via textContent, zodat de ingetikte tekst nooit als HTML landt
      lijst.innerHTML = "";
      const leeg = document.createElement("p");
      leeg.className = "zoeklaag__geen";
      leeg.textContent = `Niets gevonden voor "${invoer.value.trim()}". Probeer een ander woord.`;
      lijst.append(leeg);
      return;
    }

    lijst.innerHTML = treffers.map(kaart).join("");
  };

  // Delegatie: overleeft her-renders van de kop-balk door de editor
  document.addEventListener("click", (e) => {
    const knop = e.target.closest("[data-zoek-knop]");
    if (knop) zoeklaag.open(knop);
  });

  laag.querySelector("[data-zoek-formulier]")?.addEventListener("submit", (e) => e.preventDefault());
  laag.querySelector("[data-zoek-sluit]")?.addEventListener("click", () => zoeklaag.sluit());
  let zoekTimer;
  invoer?.addEventListener("input", () => {
    clearTimeout(zoekTimer);
    zoekTimer = setTimeout(teken, OP_SHOPIFY ? 250 : 0);
  });

  lijst?.addEventListener("click", (e) => {
    const tip = e.target.closest("[data-zoek-tip]");
    if (tip) {
      invoer.value = tip.textContent;
      teken();
      invoer.focus();
      return;
    }

    const koop = e.target.closest("[data-zoek-koop]");
    if (koop) {
      const item = ZOEKGEGEVENS.find((i) => i.id === Number(koop.dataset.zoekKoop));
      if (!item) return;
      wagen.voegToe({ id: item.id, naam: item.naam, variant: item.sub, prijs: item.prijs, beeld: item.beeld, aantal: 1 });
      // De laag blijft open; de teller op de wagenknop telt zichtbaar mee
      koop.classList.add("is-toegevoegd");
      setTimeout(() => koop.classList.remove("is-toegevoegd"), 900);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && laag.classList.contains("is-open")) zoeklaag.sluit();
  });

  document.querySelector("[data-waas]")?.addEventListener("click", () => zoeklaag.sluit());

  // Schuift de pagina opzij, dan is de weggeschoven pagina de sluitknop —
  // behalve de zoekknop erin, die opent de laag juist.
  document.querySelector("[data-pagina]")?.addEventListener("click", (e) => {
    if (!laag.classList.contains("is-open")) return;
    if (e.target.closest("[data-zoek-knop]")) return;
    e.preventDefault();
    zoeklaag.sluit();
  });

  teken();
}

/* --------------------------------------------------------------------------
   Account
   Zelfde laag-mechaniek als de winkelwagen en het zoeken. In Shopify post
   het formulier naar customer_login_url; hier laat de knop alleen zien dat
   dit het prototype is.
   -------------------------------------------------------------------------- */

/* --------------------------------------------------------------------------
   Customer Account API
   Naam en adressen wijzigen ín de accountlaag. Werkt alleen in het thema,
   en alleen als de accountkoppeling is ingesteld (thema-instellingen);
   window.THEMA_KLANT_API levert dan het client-ID en winkel-ID.

   De toegang loopt via OAuth met PKCE: de browser haalt zelf een token op
   bij Shopify. Is de klant al ingelogd, dan is die omweg vrijwel onzichtbaar
   (direct heen en terug). Het token leeft alleen in sessionStorage.
   -------------------------------------------------------------------------- */

const klantApi = {
  get instelling() {
    return (typeof window !== "undefined" && window.THEMA_KLANT_API) || null;
  },
  get actief() {
    return Boolean(this.instelling && this.instelling.clientId && this.instelling.shopId);
  },
  get authBasis() {
    return `https://shopify.com/authentication/${this.instelling.shopId}`;
  },
  get apiUrl() {
    return `https://shopify.com/${this.instelling.shopId}/account/customer/api/2025-07/graphql`;
  },

  hex(n) {
    return [...crypto.getRandomValues(new Uint8Array(n))]
      .map((b) => ("0" + b.toString(16)).slice(-2))
      .join("");
  },

  async sha256Url(tekst) {
    const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(tekst));
    return btoa(String.fromCharCode(...new Uint8Array(hash)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  },

  // Stuurt de klant langs Shopify's inlog en terug; herstelPaneel bepaalt
  // welk scherm van de laag daarna weer opengaat.
  async aanmelden(herstelPaneel) {
    const verifier = this.hex(32);
    const staat = this.hex(16);
    sessionStorage.setItem("klantapi-verifier", verifier);
    sessionStorage.setItem("klantapi-staat", staat);
    if (herstelPaneel) sessionStorage.setItem("accountlaag-herstel", herstelPaneel);

    const url = new URL(this.authBasis + "/oauth/authorize");
    url.searchParams.set("client_id", this.instelling.clientId);
    url.searchParams.set("response_type", "code");
    url.searchParams.set("redirect_uri", location.origin + "/");
    url.searchParams.set("scope", "openid email customer-account-api:full");
    url.searchParams.set("state", staat);
    url.searchParams.set("code_challenge", await this.sha256Url(verifier));
    url.searchParams.set("code_challenge_method", "S256");
    location.href = url.toString();
  },

  // Bij terugkomst: de code uit de URL inwisselen voor een token
  // Onthoudt waaróp de inlog vastliep. Zonder dit eindigt elke hapering in
  // hetzelfde nietszeggende "opnieuw inloggen", terwijl de oorzaken heel
  // verschillend zijn: een weigering van Shopify, een verlopen sessie of een
  // afgekeurde omleiding.
  diagnose(tekst) {
    if (tekst) sessionStorage.setItem("klantapi-diagnose", tekst);
    else sessionStorage.removeItem("klantapi-diagnose");
  },

  schoonUrl() {
    const url = new URL(location.href);
    ["code", "state", "error", "error_description"].forEach((k) =>
      url.searchParams.delete(k)
    );
    history.replaceState({}, "", url);
  },

  async rondAf() {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const verifier = sessionStorage.getItem("klantapi-verifier");

    // Shopify kan zelf al nee zeggen, bijvoorbeeld bij een omleidingsadres
    // dat niet bij de koppeling geregistreerd staat.
    const geweigerd = params.get("error_description") || params.get("error");
    if (geweigerd) {
      this.diagnose("Shopify weigerde de inlog: " + geweigerd);
      sessionStorage.removeItem("klantapi-verifier");
      sessionStorage.removeItem("klantapi-staat");
      this.schoonUrl();
      return;
    }

    if (!code) {
      // Alleen melden als we ook echt onderweg waren; anders is dit gewoon
      // een normale paginabezoek zonder inlogronde.
      if (verifier) this.diagnose("Shopify stuurde geen code terug.");
      return;
    }
    if (!verifier) {
      this.diagnose("De inlogronde raakte zijn sleutel kwijt (nieuw tabblad?).");
      this.schoonUrl();
      return;
    }
    if (params.get("state") !== sessionStorage.getItem("klantapi-staat")) {
      this.diagnose("De inlogronde kwam niet overeen (state).");
      this.schoonUrl();
      return;
    }

    let res;
    try {
      res = await fetch(this.authBasis + "/oauth/token", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          grant_type: "authorization_code",
          client_id: this.instelling.clientId,
          redirect_uri: location.origin + "/",
          code,
          code_verifier: verifier,
        }),
      });
    } catch (e) {
      // Een geblokkeerde CORS-aanvraag komt hier terecht: dan staat deze
      // winkel niet als toegestane herkomst bij de koppeling.
      this.diagnose("De aanvraag naar Shopify werd geblokkeerd: " + e.message);
      sessionStorage.removeItem("klantapi-verifier");
      sessionStorage.removeItem("klantapi-staat");
      this.schoonUrl();
      return;
    }

    sessionStorage.removeItem("klantapi-verifier");
    sessionStorage.removeItem("klantapi-staat");
    this.schoonUrl();

    if (!res.ok) {
      let tekst = "";
      try {
        tekst = (await res.text()).slice(0, 200);
      } catch (e) {
        tekst = "";
      }
      this.diagnose(`Token-uitwisseling gaf ${res.status}. ${tekst}`);
      return;
    }

    const token = await res.json();
    if (!token || !token.access_token) {
      // Zonder deze controle belandde de tekst "undefined" als token in de
      // opslag, en dan blijft alles daarna hangen op een 401.
      this.diagnose("Shopify gaf geen token terug in zijn antwoord.");
      return;
    }

    this.diagnose("");
    sessionStorage.setItem("klantapi-token", token.access_token);
  },

  // Eén GraphQL-vraag; zonder (geldig) token vragen we om opnieuw aanmelden.
  //
  // 401 en 403 zijn niet hetzelfde en stonden hier eerst op één hoop. 401 is
  // een verlopen token: opnieuw aanmelden helpt. 403 is een weigering: dan
  // mag deze klant of deze koppeling dit verzoek niet doen, en opnieuw
  // aanmelden brengt je alleen in een kringetje. Vandaar dat een weigering nu
  // gewoon als fout terugkomt, met wat Shopify erover zegt.
  async vraag(query, variables) {
    const token = sessionStorage.getItem("klantapi-token");
    if (!token) return { aanmeldenNodig: true };

    const res = await fetch(this.apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ query, variables }),
    });

    if (res.status === 401) {
      sessionStorage.removeItem("klantapi-token");
      return { aanmeldenNodig: true };
    }

    if (res.status === 403) {
      let tekst = "";
      try {
        tekst = (await res.text()).slice(0, 200);
      } catch (e) {
        tekst = "";
      }
      return {
        verboden: true,
        status: 403,
        errors: [{ message: "Shopify weigerde dit verzoek (403). " + tekst }],
      };
    }

    return res.json();
  },
};

const accountlaag = {
  open(opener) {
    const laag = document.querySelector("[data-accountlaag]");
    if (!laag) return;

    this.opener = opener ?? null;
    laag.classList.add("is-open");
    laag.inert = false;
    laag.setAttribute("aria-hidden", "false");

    if (!paginaOpzij.vast("lade")) {
      document.querySelector("[data-waas]")?.classList.add("is-open");
    }

    document.body.classList.add("lade-open");
    setTimeout(() => laag.querySelector("input")?.focus(), 350);
  },

  sluit() {
    const laag = document.querySelector("[data-accountlaag]");
    if (!laag || !laag.classList.contains("is-open")) return;

    laag.classList.remove("is-open");
    laag.inert = true;
    laag.setAttribute("aria-hidden", "true");
    document.querySelector("[data-waas]")?.classList.remove("is-open");
    document.body.classList.remove("lade-open");
    paginaOpzij.los();
    this.opener = null;
  },
};

/* --------------------------------------------------------------------------
   Profielfoto

   De klant kiest een foto, de browser verkleint hem tot een vierkant van 256
   pixels en schrijft hem als tekst (data-URL) in zijn eigen metafield
   klant.profielfoto. Er komt dus nergens een bestand te staan: de foto zit
   in het klantrecord en verdwijnt mee als dat record verdwijnt.

   Verkleinen in de browser doet twee dingen tegelijk. Het houdt de waarde
   ruim onder het plafond van een tekst-metafield, en het gooit alle metadata
   weg: een telefoonfoto draagt vaak GPS-coordinaten mee, en die tekenen we
   niet mee als we de foto opnieuw op een canvas zetten.

   Schrijven gebeurt met het klanttoken dat de accountlaag toch al ophaalt.
   Een klant kan dus alleen zijn eigen record raken; er is geen eigen
   inlogsysteem dat dat moet bewaken.
   -------------------------------------------------------------------------- */

const PROFIELFOTO = {
  maat: 256,
  kwaliteit: 0.82,
  // Een tekst-metafield gaat tot 65.535 tekens; hier blijven we ruim onder.
  maxTekens: 60000,
};

/* --------------------------------------------------------------------------
   Postcode-zoeker

   Nederlandse adressen invullen op postcode en huisnummer, met de open
   adresdata van het Kadaster (PDOK Locatieserver). Gratis, geen sleutel, geen
   account, en het draait rechtstreeks vanuit de browser.

   Strikt zoeken op postcode én huisnummer, niet met de vrije zoekopdracht van
   diezelfde dienst: die geeft op "2611HB 1" gewoon huisnummer 169 terug, en
   zoiets wil je niet ongemerkt in het adres van een klant zetten.

   Straat en plaats blijven gewone invoervelden. Staat een adres niet in de
   data, of hapert de dienst, dan typt de klant het zelf en gaat alles door.
   -------------------------------------------------------------------------- */

/* --------------------------------------------------------------------------
   Bewaren: verlanglijst en leeslijst

   Allebei een lijst-metafield op de klant zelf (klant.verlanglijst met
   productverwijzingen, klant.leeslijst met artikelverwijzingen), die de klant
   met zijn eigen inlog mag schrijven. Er komt dus geen app of server aan te
   pas, en de lijst verdwijnt met het klantrecord als dat verdwijnt.

   Let op: schrijven vervangt altijd de héle lijst. De volledige inhoud staat
   daarom in [data-bewaarlijsten] in de accountlaag, ook de items die niet op
   deze pagina staan. Twee tabbladen tegelijk kunnen elkaar dus overschrijven;
   voor een verlanglijst is dat de eenvoud waard.
   -------------------------------------------------------------------------- */

const BEWAARLIJSTEN = {
  product: { sleutel: "verlanglijst", type: "list.product_reference", soort: "Product" },
  artikel: { sleutel: "leeslijst", type: "list.article_reference", soort: "Article" },
};

function initBewaren() {
  if (document.body.dataset.bewarenInit) return;
  document.body.dataset.bewarenInit = "1";

  const bron = document.querySelector("[data-bewaarlijsten]");
  const klantId = (bron && bron.dataset.klant) || "";

  const uitAttribuut = (naam) =>
    new Set(((bron && bron.dataset[naam]) || "").split(",").filter(Boolean));

  const lijsten = {
    product: uitAttribuut("verlanglijst"),
    artikel: uitAttribuut("leeslijst"),
  };

  const knoppenVoor = (soort, id) =>
    document.querySelectorAll(
      '[data-bewaar="' + soort + '"][data-id="' + id + '"]'
    );

  const toon = (soort, id) => {
    const aan = lijsten[soort].has(String(id));
    knoppenVoor(soort, id).forEach((knop) => {
      knop.classList.toggle("is-bewaard", aan);
      knop.setAttribute("aria-pressed", String(aan));

      const teken = knop.querySelector("use");
      if (teken && knop.dataset.tekenAan && knop.dataset.tekenUit) {
        teken.setAttribute("href", aan ? knop.dataset.tekenAan : knop.dataset.tekenUit);
      }

      const woord = knop.querySelector("[data-bewaar-woord]");
      if (woord && knop.dataset.woordAan && knop.dataset.woordUit) {
        woord.textContent = aan ? knop.dataset.woordAan : knop.dataset.woordUit;
      }

      if (knop.dataset.labelAan && knop.dataset.labelUit) {
        knop.setAttribute("aria-label", aan ? knop.dataset.labelAan : knop.dataset.labelUit);
      }
    });

    // De teller in het accountoverzicht loopt mee
    const teller = document.querySelector(
      '[data-telling="' + BEWAARLIJSTEN[soort].sleutel + '"]'
    );
    if (teller) teller.textContent = String(lijsten[soort].size);
  };

  const schrijf = async (soort) => {
    const spec = BEWAARLIJSTEN[soort];
    const waarde = JSON.stringify(
      [...lijsten[soort]].map((id) => "gid://shopify/" + spec.soort + "/" + id)
    );

    const query = `mutation($metafields: [MetafieldsSetInput!]!) {
      metafieldsSet(metafields: $metafields) {
        metafields { key }
        userErrors { field message code }
      }
    }`;
    const variables = {
      metafields: [
        {
          ownerId: klantId,
          namespace: "klant",
          key: spec.sleutel,
          type: spec.type,
          value: waarde,
        },
      ],
    };

    // Zelfde vangnet als de andere formulieren: verloopt de inlog, dan voeren
    // we de opdracht na terugkomst alsnog uit in plaats van hem te verliezen.
    sessionStorage.setItem(
      "klantapi-opdracht",
      JSON.stringify({ query, variables })
    );

    const uit = await klantApi.vraag(query, variables);
    if (uit.aanmeldenNodig) {
      klantApi.aanmelden("overzicht");
      return "omgeleid";
    }
    sessionStorage.removeItem("klantapi-opdracht");

    if (uit.errors && uit.errors.length) return uit.errors[0].message;
    const antwoord = uit.data && uit.data.metafieldsSet;
    if (!antwoord) return "Shopify gaf een onverwacht antwoord.";
    if (antwoord.userErrors && antwoord.userErrors.length) {
      return antwoord.userErrors[0].message;
    }
    return null;
  };

  document.addEventListener("click", async (e) => {
    const knop = e.target.closest("[data-bewaar]");
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();

    // Uitgelogd: geen lijst om in te bewaren, dus eerst de accountlaag
    if (!klantId || !klantApi.actief) {
      accountlaag.open(knop);
      return;
    }

    const soort = knop.dataset.bewaar;
    const id = String(knop.dataset.id);
    if (!BEWAARLIJSTEN[soort] || !id) return;

    const wasAan = lijsten[soort].has(id);
    if (wasAan) lijsten[soort].delete(id);
    else lijsten[soort].add(id);
    toon(soort, id); // meteen zichtbaar; het schrijven mag daarna gebeuren

    const fout = await schrijf(soort);
    if (fout === "omgeleid") return;

    if (!fout) {
      // De panelen in de accountlaag komen uit Liquid en weten hier niets
      // van; ze halen zichzelf opnieuw op zodra je ze opent.
      document
        .querySelectorAll(
          '[data-account-paneel="verlanglijst"], [data-account-paneel="leeslijst"]'
        )
        .forEach((paneel) => {
          paneel.dataset.verouderd = "1";
        });
    }

    if (fout) {
      // Niet gelukt: terugdraaien, zodat het scherm niet iets anders beweert
      // dan wat er is opgeslagen.
      if (wasAan) lijsten[soort].add(id);
      else lijsten[soort].delete(id);
      toon(soort, id);
      knop.setAttribute("title", fout);
    }
  });
}

function initAdresZoeker(wortel = document) {
  const vorm = wortel.querySelector?.("[data-adres-formulier]");
  if (!vorm || vorm.dataset.zoekerInit) return;
  vorm.dataset.zoekerInit = "1";

  const v = vorm.elements;
  const postcode = v.postcode;
  const nummer = v.huisnummer;
  const straat = v.straat;
  const stad = v.stad;
  const land = v.land;
  const melding = vorm.querySelector("[data-adres-gevonden]");
  if (!postcode || !nummer || !straat || !stad) return;

  const zeg = (tekst, soort) => {
    if (!melding) return;
    melding.textContent = tekst || "";
    melding.hidden = !tekst;
    if (soort) melding.dataset.toon = soort;
    else delete melding.dataset.toon;
  };

  // 1234AB, met of zonder spatie; een postbus of buitenlandse code valt af
  const nlPostcode = (waarde) => {
    const schoon = String(waarde || "").toUpperCase().replace(/\s+/g, "");
    return /^[1-9][0-9]{3}[A-Z]{2}$/.test(schoon) ? schoon : null;
  };

  let laatste = "";
  let wacht;

  const zoek = async () => {
    if (land && land.value !== "NL") {
      zeg("");
      return;
    }
    const pc = nlPostcode(postcode.value);
    const nr = (String(nummer.value).match(/\d+/) || [])[0];
    if (!pc || !nr) {
      zeg("");
      return;
    }

    const sleutel = pc + "-" + nr;
    if (sleutel === laatste) return;
    laatste = sleutel;

    zeg("Even opzoeken…");

    const params = new URLSearchParams();
    params.set("q", "*");
    params.set("fl", "straatnaam,woonplaatsnaam");
    params.set("rows", "1");
    params.append("fq", "type:adres");
    params.append("fq", "postcode:" + pc);
    params.append("fq", "huisnummer:" + nr);

    try {
      const res = await fetch(
        "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?" + params
      );
      const json = await res.json();
      const doc = json.response && json.response.docs && json.response.docs[0];
      if (!doc) {
        zeg("Dit adres kennen we niet. Vul straat en plaats zelf in.");
        return;
      }
      straat.value = doc.straatnaam || "";
      stad.value = doc.woonplaatsnaam || "";
      // Netjes teruggeschreven: 1234 AB, zoals iedereen het schrijft
      postcode.value = pc.slice(0, 4) + " " + pc.slice(4);
      zeg(doc.straatnaam + " " + nr + ", " + doc.woonplaatsnaam, "goed");
    } catch (e) {
      zeg("Opzoeken lukte even niet. Vul straat en plaats zelf in.");
    }
  };

  const plan = () => {
    clearTimeout(wacht);
    wacht = setTimeout(zoek, 400);
  };

  [postcode, nummer].forEach((veld) => {
    veld.addEventListener("input", plan);
    veld.addEventListener("blur", zoek);
  });

  land?.addEventListener("change", () => {
    laatste = "";
    zoek();
  });
}

function initProfielfoto(wortel = document) {
  const vak = wortel.querySelector?.("[data-profielfoto]");
  if (!vak || vak.dataset.fotoInit) return;
  vak.dataset.fotoInit = "1";

  const laag = vak.closest("[data-accountlaag]") || document;
  const veld = vak.querySelector("[data-foto-kies]");
  const wegKnop = vak.querySelector("[data-foto-weg]");
  const label = vak.querySelector("[data-foto-label]");
  const melding = vak.querySelector("[data-foto-melding]");
  // De knop in de kop-balk, het profiel in de laag en een eventuele eigen
  // reactie onder een artikel. Nadrukkelijk alleen "eigen": onder een artikel
  // staan ook avatars van andere mensen, en die horen niet mee te veranderen.
  const avatars = () => document.querySelectorAll('[data-avatar="eigen"]');
  const rusttekst = melding ? melding.textContent.trim() : "";

  const snijder = laag.querySelector("[data-snijder]");
  const doek = laag.querySelector("[data-snij-doek]");
  const zoom = laag.querySelector("[data-snij-zoom]");
  const klaarKnop = laag.querySelector("[data-snij-klaar]");
  const afKnop = laag.querySelector("[data-snij-af]");
  const snijMelding = laag.querySelector("[data-snij-melding]");

  const zeg = (tekst, soort) => {
    if (!melding) return;
    melding.textContent = tekst || rusttekst;
    if (soort) melding.dataset.toon = soort;
    else delete melding.dataset.toon;
  };

  const zegSnij = (tekst, soort) => {
    if (!snijMelding) return;
    snijMelding.textContent = tekst || "";
    snijMelding.hidden = !tekst;
    if (soort) snijMelding.dataset.toon = soort;
    else delete snijMelding.dataset.toon;
  };

  const bezig = (aan) => {
    if (aan) vak.dataset.bezig = "1";
    else delete vak.dataset.bezig;
  };

  const toonPaneel = (naam) => {
    if (typeof laag._toonPaneel === "function") laag._toonPaneel(naam);
  };

  // De avatar bijwerken zonder de pagina te herladen; bij het volgende
  // bezoek tekent Liquid hem alsnog uit het metafield.
  const toonInAvatar = (dataUrl) => {
    avatars().forEach((avatar) => {
      avatar.innerHTML = "";
      if (dataUrl) {
        const beeld = document.createElement("img");
        beeld.className = "klantavatar__foto";
        beeld.alt = "";
        beeld.setAttribute("data-avatar-foto", "");
        beeld.src = dataUrl;
        avatar.appendChild(beeld);
      } else {
        const letters = document.createElement("span");
        letters.className = "klantavatar__letters";
        letters.textContent = avatar.dataset.initialen || vak.dataset.initialen || "";
        avatar.appendChild(letters);
      }
    });
  };

  const gelukt = (dataUrl) => {
    toonInAvatar(dataUrl);
    if (label) label.textContent = "Andere foto";
    if (wegKnop) wegKnop.hidden = false;
    zeg("Gelukt, je foto staat erop.");
    setTimeout(() => zeg(""), 4000);
  };

  /* --- Schrijven naar het eigen metafield ------------------------------- */

  // Geeft de eerste bruikbare foutmelding terug, of null als het gelukt is.
  const foutIn = (uit) => {
    if (!uit) return "Er ging iets mis.";
    if (uit.aanmeldenNodig) return "aanmelden";
    if (uit.errors && uit.errors.length) return uit.errors[0].message;
    const eerste = Object.values(uit.data || {})[0];
    if (eerste && eerste.userErrors && eerste.userErrors.length) {
      return eerste.userErrors[0].message;
    }
    return null;
  };

  const schrijfPoging = (waarde, metEigenaar) => {
    const veldje = {
      namespace: "klant",
      key: "profielfoto",
      type: "multi_line_text_field",
      value: waarde,
    };
    // De Customer Account API weet zelf wie er ingelogd is. Sommige versies
    // willen de eigenaar er expliciet bij, andere wijzen hem juist af, dus we
    // proberen beide voor we concluderen dat het niet mag.
    if (metEigenaar) veldje.ownerId = vak.dataset.klant;

    return klantApi.vraag(
      `mutation($metafields: [MetafieldsSetInput!]!) {
        metafieldsSet(metafields: $metafields) {
          metafields { key }
          userErrors { field message code }
        }
      }`,
      { metafields: [veldje] }
    );
  };

  const schrijf = async (waarde) => {
    const eerste = await schrijfPoging(waarde, true);
    const fout = foutIn(eerste);
    if (!fout || fout === "aanmelden") return eerste;
    const tweede = await schrijfPoging(waarde, false);
    // Lukt het zonder eigenaar ook niet, dan is de eerste melding de eerlijkste
    return foutIn(tweede) ? eerste : tweede;
  };

  const wis = () =>
    klantApi.vraag(
      `mutation($metafields: [MetafieldIdentifierInput!]!) {
        metafieldsDelete(metafields: $metafields) {
          deletedMetafields { key }
          userErrors { field message }
        }
      }`,
      {
        metafields: [
          { ownerId: vak.dataset.klant, namespace: "klant", key: "profielfoto" },
        ],
      }
    );

  /* --- De inlogomweg overleven ------------------------------------------
     Zonder token in deze sessie stuurt Shopify je eerst langs zijn eigen
     inlog. Dat oogt als een verversing, en de gekozen foto zou daarbij
     verdwijnen. Daarom leggen we de bijgesneden foto apart vóór we het
     proberen, en pakken we hem na terugkomst zelf weer op. */

  const WACHTSLEUTEL = "profielfoto-wacht";

  const wachtOpToken = async (ms = 5000) => {
    const eind = Date.now() + ms;
    while (Date.now() < eind) {
      if (sessionStorage.getItem("klantapi-token")) return true;
      await new Promise((r) => setTimeout(r, 150));
    }
    return Boolean(sessionStorage.getItem("klantapi-token"));
  };

  const bewaarEnSchrijf = async (dataUrl) => {
    sessionStorage.setItem(WACHTSLEUTEL, dataUrl);
    const fout = foutIn(await schrijf(dataUrl));
    if (fout === "aanmelden") {
      klantApi.aanmelden("overzicht");
      return "omgeleid";
    }
    sessionStorage.removeItem(WACHTSLEUTEL);
    return fout;
  };

  (async () => {
    const wachtend = sessionStorage.getItem(WACHTSLEUTEL);
    if (!wachtend) return;
    // Meteen weghalen: één poging na terugkomst, anders blijf je heen en
    // weer gestuurd worden als het schrijven principieel niet mag.
    sessionStorage.removeItem(WACHTSLEUTEL);

    bezig(true);
    zeg("Even opslaan…");

    // De laag hoort na de omweg gewoon weer open te staan met je account.
    if (typeof accountlaag?.open === "function") accountlaag.open();
    toonPaneel("overzicht");

    if (!(await wachtOpToken())) {
      bezig(false);
      const waarom = sessionStorage.getItem("klantapi-diagnose");
      zeg(waarom || "Inloggen bij Shopify lukte niet. Probeer het nog een keer.", "fout");
      return;
    }

    const fout = foutIn(await schrijf(wachtend));
    bezig(false);
    if (fout) {
      zeg(
        fout === "aanmelden"
          ? "Shopify wees het opslaan af (token afgewezen)."
          : fout,
        "fout"
      );
      return;
    }
    gelukt(wachtend);
  })();

  /* --- Bijsnijden -------------------------------------------------------- */

  let bron = null;
  let schaal = 1;
  let x = 0;
  let y = 0;

  const zijdeVan = () => doek?.clientWidth || 280;

  // Hoeveel de foto minimaal geschaald moet worden om het rondje te vullen
  const dekking = () => {
    const zijde = zijdeVan();
    return Math.max(zijde / bron.naturalWidth, zijde / bron.naturalHeight);
  };

  // De foto mag nooit van het rondje af schuiven
  const klem = () => {
    const zijde = zijdeVan();
    const s = dekking() * schaal;
    const maxX = Math.max(0, (bron.naturalWidth * s - zijde) / 2);
    const maxY = Math.max(0, (bron.naturalHeight * s - zijde) / 2);
    x = Math.min(maxX, Math.max(-maxX, x));
    y = Math.min(maxY, Math.max(-maxY, y));
  };

  const teken = () => {
    if (!bron || !doek) return;
    const zijde = zijdeVan();
    const scherpte = Math.min(2, window.devicePixelRatio || 1);
    if (doek.width !== Math.round(zijde * scherpte)) {
      doek.width = Math.round(zijde * scherpte);
      doek.height = Math.round(zijde * scherpte);
    }
    const penseel = doek.getContext("2d");
    penseel.setTransform(scherpte, 0, 0, scherpte, 0, 0);
    penseel.clearRect(0, 0, zijde, zijde);
    penseel.imageSmoothingQuality = "high";
    klem();
    const s = dekking() * schaal;
    const b = bron.naturalWidth * s;
    const h = bron.naturalHeight * s;
    penseel.drawImage(bron, (zijde - b) / 2 + x, (zijde - h) / 2 + y, b, h);
  };

  // Hetzelfde beeld, maar op 256 pixels: wat je ziet is wat je opslaat.
  const snijUit = () => {
    const maat = PROFIELFOTO.maat;
    const uitDoek = document.createElement("canvas");
    uitDoek.width = maat;
    uitDoek.height = maat;
    const penseel = uitDoek.getContext("2d");
    penseel.imageSmoothingQuality = "high";
    const factor = maat / zijdeVan();
    const s = dekking() * schaal * factor;
    const b = bron.naturalWidth * s;
    const h = bron.naturalHeight * s;
    penseel.drawImage(bron, (maat - b) / 2 + x * factor, (maat - h) / 2 + y * factor, b, h);
    let uit = uitDoek.toDataURL("image/webp", PROFIELFOTO.kwaliteit);
    if (!uit.startsWith("data:image/webp")) {
      uit = uitDoek.toDataURL("image/jpeg", PROFIELFOTO.kwaliteit);
    }
    return uit;
  };

  // Slepen met muis of vinger
  let sleep = null;
  snijder?.addEventListener("pointerdown", (e) => {
    if (!bron) return;
    sleep = { x: e.clientX, y: e.clientY };
    snijder.setPointerCapture(e.pointerId);
  });

  snijder?.addEventListener("pointermove", (e) => {
    if (!sleep) return;
    x += e.clientX - sleep.x;
    y += e.clientY - sleep.y;
    sleep = { x: e.clientX, y: e.clientY };
    teken();
  });

  const laatLos = () => {
    sleep = null;
  };
  snijder?.addEventListener("pointerup", laatLos);
  snijder?.addEventListener("pointercancel", laatLos);

  snijder?.addEventListener(
    "wheel",
    (e) => {
      if (!bron) return;
      e.preventDefault();
      schaal = Math.min(4, Math.max(1, schaal * (1 - e.deltaY / 500)));
      if (zoom) zoom.value = String(schaal);
      teken();
    },
    { passive: false }
  );

  zoom?.addEventListener("input", () => {
    schaal = Number(zoom.value) || 1;
    teken();
  });

  /* --- Kiezen, opslaan, weghalen ---------------------------------------- */

  veld?.addEventListener("change", () => {
    const bestand = veld.files && veld.files[0];
    if (!bestand) return;
    if (!klantApi.actief) {
      zeg("De accountkoppeling staat uit.", "fout");
      return;
    }

    const url = URL.createObjectURL(bestand);
    const beeld = new Image();

    beeld.onload = () => {
      URL.revokeObjectURL(url);
      veld.value = "";
      if (!beeld.naturalWidth) {
        zeg("Deze afbeelding kon ik niet lezen.", "fout");
        return;
      }
      bron = beeld;
      schaal = 1;
      x = 0;
      y = 0;
      if (zoom) zoom.value = "1";
      zegSnij("");
      toonPaneel("foto");
      // Twee keer tekenen: meteen, zodat er nooit een leeg rondje staat, en
      // nog eens zodra het paneel echt zichtbaar is, want daarvóór is de
      // breedte nul en valt hij terug op een geschatte maat.
      teken();
      requestAnimationFrame(teken);
    };

    beeld.onerror = () => {
      URL.revokeObjectURL(url);
      veld.value = "";
      zeg("Dit bestand is geen afbeelding die ik kan openen.", "fout");
    };

    beeld.src = url;
  });

  klaarKnop?.addEventListener("click", async () => {
    if (!bron) return;
    zegSnij("Even opslaan…");

    const dataUrl = snijUit();
    if (dataUrl.length > PROFIELFOTO.maxTekens) {
      zegSnij("Deze foto blijft te groot. Zoom iets verder in of kies een andere.", "fout");
      return;
    }

    const fout = await bewaarEnSchrijf(dataUrl);
    if (fout === "omgeleid") return;
    if (fout) {
      zegSnij(fout, "fout");
      return;
    }

    bron = null;
    zegSnij("");
    toonPaneel("overzicht");
    gelukt(dataUrl);
  });

  afKnop?.addEventListener("click", () => {
    bron = null;
    zegSnij("");
    toonPaneel("overzicht");
  });

  wegKnop?.addEventListener("click", async () => {
    bezig(true);
    zeg("Even weghalen…");

    let fout = foutIn(await wis());
    // Kan de wismutatie niet, dan schrijven we hem leeg. Het resultaat is
    // hetzelfde: er staat geen foto meer in het klantrecord.
    if (fout && fout !== "aanmelden") fout = foutIn(await schrijf(""));

    if (fout === "aanmelden") {
      klantApi.aanmelden("overzicht");
      return;
    }

    bezig(false);
    if (fout) {
      zeg(fout, "fout");
      return;
    }

    toonInAvatar(null);
    if (label) label.textContent = "Foto toevoegen";
    wegKnop.hidden = true;
    zeg("Je foto is verwijderd.");
    setTimeout(() => zeg(""), 4000);
  });
}

function initAccount(wortel = document) {
  const laag = document.querySelector("[data-accountlaag]");
  if (!laag || laag.dataset.accountInit) return;
  laag.dataset.accountInit = "1";

  // Delegatie: overleeft her-renders van de kop-balk door de editor
  document.addEventListener("click", (e) => {
    const knop = e.target.closest("[data-account-knop]");
    if (knop) accountlaag.open(knop);
  });

  // Ingelogd (thema): de laag is een mini-app met panelen. Doorklikken via
  // data-account-ga, terug via data-account-terug; bij openen start het
  // overzicht. Zonder panelen (uitgelogd of prototype) doet dit niets.
  const app = laag.querySelector("[data-account-app]");
  if (app) {
    const panelen = [...app.querySelectorAll("[data-account-paneel]")];
    const balkTitel = laag.querySelector("[data-account-titel]");
    const balkTerug = laag.querySelector("[data-account-terug]");

    /* Een lijstpaneel (verlanglijst, leeslijst) tekent Liquid bij het laden
       van de pagina. Klik je daarna een hartje aan, dan klopt de inhoud niet
       meer, terwijl het metafield allang bijgewerkt is. In plaats van de hele
       pagina te herladen halen we alleen dít paneel opnieuw op. */
    const versPaneel = async (paneel) => {
      delete paneel.dataset.verouderd;
      paneel.dataset.bezig = "1";
      try {
        const res = await fetch(location.href, { credentials: "same-origin" });
        const doc = new DOMParser().parseFromString(await res.text(), "text/html");
        const vers = doc.querySelector(
          '[data-account-paneel="' + paneel.dataset.accountPaneel + '"]'
        );
        if (vers) paneel.innerHTML = vers.innerHTML;
      } catch (e) {
        // Niet gelukt: de oude inhoud laten staan is beter dan een leeg vak
      }
      delete paneel.dataset.bezig;
    };

    const toon = (naam) => {
      let actief = null;
      panelen.forEach((paneel) => {
        const dit = paneel.dataset.accountPaneel === naam;
        paneel.hidden = !dit;
        paneel.classList.toggle("is-actief", dit);
        if (dit) actief = paneel;
      });
      // De app-balk volgt het paneel: titel in het midden, terug alleen
      // buiten het overzicht.
      if (balkTitel) balkTitel.textContent = (actief && actief.dataset.titel) || "Account";
      if (balkTerug) balkTerug.hidden = naam === "overzicht";
      app.scrollTop = 0;

      if (actief && actief.dataset.verouderd) versPaneel(actief);
    };

    laag.addEventListener("click", (e) => {
      const ga = e.target.closest("[data-account-ga]");
      if (ga) {
        toon(ga.dataset.accountGa);
        return;
      }
      if (e.target.closest("[data-account-terug]")) {
        // Terug volgt het paneel: een formulier keert terug naar zijn lijst
        const actief = panelen.find((paneel) => !paneel.hidden);
        toon((actief && actief.dataset.terug) || "overzicht");
      }
    });

    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-account-knop]")) toon("overzicht");
    });

    // De fotocode zit in een eigen functie en moet ook van paneel kunnen
    // wisselen (naar het bijsnijden en weer terug).
    laag._toonPaneel = toon;

    /* --- Bewerken via de Customer Account API --------------------------- */

    const meldingIn = (vorm, tekst) => {
      const melding = vorm.querySelector("[data-formulier-melding]") ||
        laag.querySelector("[data-adressen-melding]");
      if (!melding) return;
      melding.textContent = tekst;
      melding.hidden = false;
    };

    // Na een geslaagde wijziging tekent Liquid de laag opnieuw; de vlag
    // zorgt dat we na de herlaadbeurt hetzelfde scherm weer openen.
    const klaarEnVers = (paneel) => {
      sessionStorage.setItem("accountlaag-herstel", paneel);
      location.reload();
    };

    // Geen antwoord is geen succes. Hier stond eerder alleen een controle op
    // foutlijsten, en een leeg of onverwacht antwoord gold daardoor als
    // "opgeslagen": de laag herlaadde vrolijk terwijl er niets veranderd was.
    const foutuit = (uit) => {
      if (!uit) return "Er kwam geen antwoord van Shopify.";
      if (uit.errors && uit.errors.length) return uit.errors[0].message;
      if (!uit.data) return "Shopify gaf een onverwacht antwoord.";
      const eerste = Object.values(uit.data)[0];
      if (eerste === undefined) return "Shopify gaf een onverwacht antwoord.";
      if (eerste === null) return "Shopify kon dit niet uitvoeren.";
      if (eerste.userErrors && eerste.userErrors.length) {
        return eerste.userErrors[0].message;
      }
      return null;
    };

    const stuur = async (vorm, herstelPaneel, query, variables, klaarPaneel) => {
      if (!klantApi.actief) return;
      meldingIn(vorm, "Even opslaan…");

      // De opdracht eerst vastleggen. Verloopt de inlog onderweg, dan gaat de
      // klant langs Shopify en voeren we hem na terugkomst alsnog uit. Zonder
      // dit verdampt alles wat hij net heeft ingevuld bij die omweg, en dat
      // ziet eruit als "opslaan doet niets".
      sessionStorage.setItem(
        "klantapi-opdracht",
        JSON.stringify({ query, variables, klaarPaneel })
      );

      const uit = await klantApi.vraag(query, variables);
      if (uit.aanmeldenNodig) {
        klantApi.aanmelden(herstelPaneel);
        return;
      }
      sessionStorage.removeItem("klantapi-opdracht");

      const fout = foutuit(uit);
      if (fout) {
        meldingIn(vorm, fout);
        return;
      }
      klaarEnVers(klaarPaneel);
    };

    laag.querySelector("[data-naam-formulier]")?.addEventListener("submit", (e) => {
      e.preventDefault();
      const v = e.target.elements;
      stuur(e.target, "gegevens",
        `mutation($input: CustomerUpdateInput!) {
          customerUpdate(input: $input) { userErrors { message } }
        }`,
        { input: { firstName: v.voornaam.value.trim(), lastName: v.achternaam.value.trim() } },
        "gegevens");
    });

    const adresVorm = laag.querySelector("[data-adres-formulier]");

    const adresGid = (id) => `gid://shopify/CustomerAddress/${id}`;

    adresVorm?.addEventListener("submit", (e) => {
      e.preventDefault();
      const v = e.target.elements;
      // Shopify wil straat en huisnummer op één regel; het formulier vraagt ze
      // apart, omdat de postcodezoeker anders niets heeft om op te zoeken.
      const straat = v.straat.value.trim();
      const huisnummer = v.huisnummer.value.trim();
      const adres = {
        firstName: v.voornaam.value.trim(),
        lastName: v.achternaam.value.trim(),
        address1: [straat, huisnummer].filter(Boolean).join(" "),
        address2: v.adres2.value.trim(),
        zip: v.postcode.value.trim(),
        city: v.stad.value.trim(),
        phoneNumber: v.telefoon.value.trim() || null,
        territoryCode: v.land ? v.land.value : "NL",
      };
      const standaard = v.standaard.checked;

      if (v.adresId.value) {
        stuur(e.target, "adres-vorm",
          `mutation($id: ID!, $address: CustomerAddressInput!, $default: Boolean) {
            customerAddressUpdate(addressId: $id, address: $address, defaultAddress: $default) {
              userErrors { message }
            }
          }`,
          { id: adresGid(v.adresId.value), address: adres, default: standaard },
          "adressen");
      } else {
        stuur(e.target, "adres-vorm",
          `mutation($address: CustomerAddressInput!, $default: Boolean) {
            customerAddressCreate(address: $address, defaultAddress: $default) {
              userErrors { message }
            }
          }`,
          { address: adres, default: standaard },
          "adressen");
      }
    });

    laag.addEventListener("click", (e) => {
      const nieuwKnop = e.target.closest("[data-adres-nieuw]");
      const bewerkKnop = e.target.closest("[data-adres-bewerk]");
      const verwijderKnop = e.target.closest("[data-adres-verwijder]");
      if (!adresVorm || (!nieuwKnop && !bewerkKnop && !verwijderKnop)) return;

      if (verwijderKnop) {
        if (!window.confirm("Dit adres verwijderen?")) return;
        stuur(verwijderKnop.closest(".accountlaag__paneel"), "adressen",
          `mutation($id: ID!) {
            customerAddressDelete(addressId: $id) { userErrors { message } }
          }`,
          { id: adresGid(verwijderKnop.dataset.id) },
          "adressen");
        return;
      }

      const d = bewerkKnop ? bewerkKnop.dataset : {};
      const v = adresVorm.elements;
      // "Oude Delft 169" gaat terug naar twee velden: alles tot het laatste
      // stuk met een cijfer is de straat, de rest het huisnummer. Klopt de
      // gok niet, dan corrigeert de klant hem gewoon zelf.
      const heel = (d.adres1 || "").trim();
      const gesplitst = heel.match(/^(.*?)\s*(\d[\dA-Za-z\-\/ ]*)$/);
      v.adresId.value = d.id || "";
      v.voornaam.value = d.voornaam || "";
      v.achternaam.value = d.achternaam || "";
      v.straat.value = gesplitst ? gesplitst[1].trim() : heel;
      v.huisnummer.value = gesplitst ? gesplitst[2].trim() : "";
      v.adres2.value = d.adres2 || "";
      if (v.land) v.land.value = d.land || "NL";
      v.postcode.value = d.postcode || "";
      v.stad.value = d.stad || "";
      v.telefoon.value = d.telefoon || "";
      v.standaard.checked = Boolean(d.standaard);
      toon("adres-vorm");
    });

    /* --- Terugkomst na inloggen of opslaan ------------------------------- */

    (async () => {
      if (klantApi.actief) await klantApi.rondAf();

      // Bleef er een opdracht liggen op de inlogomweg? Die nu alsnog
      // uitvoeren, zodat het adres of de naam die de klant al had ingevuld
      // niet alsnog verloren gaat.
      const bewaard = sessionStorage.getItem("klantapi-opdracht");
      if (bewaard) {
        // Meteen weghalen: één poging, anders blijf je rondjes draaien als
        // het principieel niet mag.
        sessionStorage.removeItem("klantapi-opdracht");
        try {
          const opdracht = JSON.parse(bewaard);
          const uit = await klantApi.vraag(opdracht.query, opdracht.variables);
          const fout = foutuit(uit);
          if (!fout) {
            klaarEnVers(opdracht.klaarPaneel);
            return;
          }
          accountlaag.open();
          toon(opdracht.klaarPaneel || "overzicht");
          const melding = laag.querySelector("[data-adressen-melding]");
          if (melding) {
            melding.textContent = fout;
            melding.hidden = false;
          }
        } catch (e) {
          // Onleesbare opdracht: niets doen, liever niets dan iets verkeerds
        }
      }

      const herstel = sessionStorage.getItem("accountlaag-herstel");
      if (herstel) {
        sessionStorage.removeItem("accountlaag-herstel");
        accountlaag.open();
        toon(herstel);
      }
    })();
  }

  initProfielfoto(laag);
  initAdresZoeker(laag);

  laag.querySelector("[data-account-sluit]")?.addEventListener("click", () => accountlaag.sluit());

  // Prototype: er is geen echte login; de melding maakt dat eerlijk zichtbaar
  laag.querySelector("[data-account-formulier]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    let melding = laag.querySelector(".accountlaag__melding");
    if (!melding) {
      melding = document.createElement("p");
      melding.className = "accountlaag__melding";
      melding.textContent = "Dit is het prototype — inloggen komt met Shopify mee.";
      e.target.append(melding);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && laag.classList.contains("is-open")) accountlaag.sluit();
  });

  document.querySelector("[data-waas]")?.addEventListener("click", () => accountlaag.sluit());

  document.querySelector("[data-pagina]")?.addEventListener("click", (e) => {
    if (!laag.classList.contains("is-open")) return;
    if (e.target.closest("[data-account-knop]")) return;
    e.preventDefault();
    accountlaag.sluit();
  });
}

/* --------------------------------------------------------------------------
   Uitgelicht product
   De radio's zijn de opties; de gekozen combinatie wijst één variant aan.
   Prijs, voorraad en knoptekst volgen die variant, en waarden die met de
   huidige keuze niet leverbaar zijn worden uitgeschakeld — hetzelfde gedrag
   als in een Shopify-thema, alleen komt de lijst hier uit dit bestand in
   plaats van uit product.variants.
   -------------------------------------------------------------------------- */

const UITGELICHT = {
  naam: "Plantenvoeding",
  beeld: "img/olla-groen.png",
  varianten: [
    { id: 45001, keuzes: { Formaat: "250 ml", Soort: "Universeel" }, prijs: 995, vanaf: null, voorraad: true },
    { id: 45002, keuzes: { Formaat: "250 ml", Soort: "Kamerplant" }, prijs: 995, vanaf: null, voorraad: true },
    { id: 45003, keuzes: { Formaat: "250 ml", Soort: "Cactus" }, prijs: 995, vanaf: null, voorraad: false },
    { id: 45004, keuzes: { Formaat: "500 ml", Soort: "Universeel" }, prijs: 1595, vanaf: 1895, voorraad: true },
    { id: 45005, keuzes: { Formaat: "500 ml", Soort: "Kamerplant" }, prijs: 1595, vanaf: 1895, voorraad: true },
    { id: 45006, keuzes: { Formaat: "500 ml", Soort: "Cactus" }, prijs: 1595, vanaf: null, voorraad: false },
  ],
};

function initKoopblok(wortel = document) {
  const blok = wortel.querySelector("[data-koopblok]");
  if (!blok) return;

  // Op de productpagina staat de echte productdata als JSON in het blok
  // (zelfde vorm als UITGELICHT); zonder die data — het prototype — valt
  // hij terug op de vaste demo-data. Alle onderdelen zijn optioneel: in de
  // editor kan elk blok (prijs, voorraad, kopen…) weggehaald zijn.
  let data = UITGELICHT;
  const bron = blok.querySelector("[data-product-json]");
  if (bron) {
    try {
      data = JSON.parse(bron.textContent);
    } catch {
      /* kapotte JSON: houd de demo-data */
    }
  }

  const sectie = blok.closest("section") || blok;
  const radios = [...blok.querySelectorAll(".optie__radio")];
  const knop = blok.querySelector("[data-toevoegen]");
  const knoptekst = blok.querySelector("[data-knoptekst]");
  const melding = blok.querySelector("[data-melding]");
  const aantalVeld = blok.querySelector("[data-aantal]");
  const minKnop = blok.querySelector("[data-aantal-min]");
  const balk = sectie.querySelector("[data-koopbalk]");
  let aantal = 1;
  let meldingTimer = null;

  // Welke waarde staat er per optie aan
  const keuze = () =>
    Object.fromEntries(
      [...blok.querySelectorAll(".optie")].map((optie) => [
        optie.dataset.optie,
        optie.querySelector(".optie__radio:checked")?.value,
      ])
    );

  const zoek = (keuzes) =>
    data.varianten.find((v) =>
      Object.entries(keuzes).every(([naam, waarde]) => v.keuzes[naam] === waarde)
    );

  // Voorraadmelding: uitverkocht, bijna op (met balkje) of gewoon op voorraad
  const toonVoorraad = (variant) => {
    const rij = sectie.querySelector("[data-voorraad]");
    if (!rij) return;
    const tekst = rij.querySelector("[data-voorraad-tekst]");
    const balkje = rij.querySelector("[data-voorraad-balk]");
    const drempel = Number(rij.dataset.drempel) || 5;
    const over = variant?.voorraad_aantal;

    rij.hidden = false;
    if (balkje) balkje.hidden = false;

    // De vulling is de stand: leeg bij uitverkocht, een deel bij bijna op,
    // helemaal vol als er ruim voorraad is.
    const vullen = (deel) => {
      const staaf = balkje?.querySelector("i");
      if (staaf) staaf.style.width = deel + "%";
    };

    if (!variant?.voorraad) {
      rij.dataset.staat = "uit";
      tekst.textContent = "Uitverkocht";
      vullen(0);
    } else if (over != null && over <= drempel) {
      rij.dataset.staat = "laag";
      tekst.textContent = `Nog ${over} op voorraad`;
      vullen(Math.max(8, Math.round((over / drempel) * 100)));
    } else if (rij.dataset.toonOpVoorraad === "true") {
      rij.dataset.staat = "op";
      tekst.textContent = over != null ? `${over} op voorraad` : "Op voorraad";
      vullen(100);
    } else {
      rij.hidden = true;
    }
  };

  // Variant met een eigen foto (zoals een kleur): galerij wisselt mee
  const toonBeeld = (variant) => {
    if (!variant?.beeld) return;
    const galerij = sectie.querySelector("[data-galerij]");
    const hoofd = galerij?.querySelector("[data-hoofdbeeld]");
    if (!hoofd || hoofd.src === variant.beeld) return;
    hoofd.src = variant.beeld;
    hoofd.removeAttribute("srcset");
    galerij.querySelectorAll("[data-thumb]").forEach((t) =>
      t.classList.toggle("is-actief", t.dataset.beeld === variant.beeld)
    );
  };

  const toon = () => {
    const gekozen = keuze();
    const variant = zoek(gekozen);

    const prijsVeld = blok.querySelector("[data-prijs]");
    if (prijsVeld) prijsVeld.textContent = geld(variant?.prijs ?? 0);

    const vanaf = blok.querySelector("[data-vanaf]");
    if (vanaf) {
      vanaf.hidden = !variant?.vanaf;
      if (variant?.vanaf) vanaf.textContent = geld(variant.vanaf);
    }

    // Kortingspil naast de prijs
    const korting = blok.querySelector("[data-korting]");
    if (korting) {
      let pct = 0;
      if (variant?.vanaf && variant.prijs) {
        pct = Math.round((1 - variant.prijs / variant.vanaf) * 100);
      }
      korting.hidden = pct <= 0;
      korting.textContent = pct > 0 ? `\u2212${pct}%` : "";
    }

    const idVeld = blok.querySelector("[data-variant-id]");
    if (idVeld) idVeld.value = variant?.id ?? "";

    const leverbaar = Boolean(variant?.voorraad);
    if (knoptekst) knoptekst.textContent = leverbaar ? "In winkelwagen" : "Uitverkocht";
    if (knop) knop.setAttribute("aria-disabled", String(!leverbaar));

    if (balk) {
      const balkPrijs = balk.querySelector("[data-balk-prijs]");
      if (balkPrijs) balkPrijs.textContent = geld(variant?.prijs ?? 0);
      const balkTekst = balk.querySelector("[data-balk-knoptekst]");
      if (balkTekst) balkTekst.textContent = leverbaar ? "In winkelwagen" : "Uitverkocht";
      balk.querySelector("[data-balk-knop]")?.toggleAttribute("disabled", !leverbaar);
    }

    toonVoorraad(variant);
    toonBeeld(variant);

    // Een waarde uitschakelen als er met de rest van de keuze niets
    // leverbaars bij te vinden is. De aangevinkte waarde blijft altijd
    // klikbaar, anders kun je niet meer terug.
    radios.forEach((radio) => {
      if (radio.checked) {
        radio.disabled = false;
        return;
      }
      const naam = radio.closest(".optie").dataset.optie;
      const proef = { ...gekozen, [naam]: radio.value };
      radio.disabled = !zoek(proef)?.voorraad;
    });
  };

  radios.forEach((radio) => radio.addEventListener("change", toon));

  const zetAantal = (nieuw) => {
    aantal = Math.min(10, Math.max(1, nieuw));
    if (aantalVeld) aantalVeld.textContent = aantal;
    if (minKnop) minKnop.disabled = aantal === 1;
  };

  minKnop?.addEventListener("click", () => zetAantal(aantal - 1));
  blok
    .querySelector("[data-aantal-plus]")
    ?.addEventListener("click", () => zetAantal(aantal + 1));

  blok.addEventListener("submit", (e) => {
    e.preventDefault(); // Shopify: via de cart-API, met de lade als bevestiging
    const variant = zoek(keuze());
    if (!variant?.voorraad) return;

    wagen.voegToe({
      id: variant.id,
      variantId: variant.id,
      naam: data.naam,
      variant: Object.values(variant.keuzes).join(" · "),
      prijs: variant.prijs,
      beeld: data.beeld,
      aantal,
    });

    if (melding) {
      melding.classList.add("is-zichtbaar");
      clearTimeout(meldingTimer);
      meldingTimer = setTimeout(() => melding.classList.remove("is-zichtbaar"), 2600);
    }

    wagen.open(knop);
    zetAantal(1);
  });

  // Vaste bestelbalk (kleine schermen): verschijnt zodra de echte koopregel
  // boven het scherm uit scrolt, en bestelt via diezelfde knop.
  if (balk && !balk.dataset.balkInit) {
    balk.dataset.balkInit = "1";
    balk
      .querySelector("[data-balk-knop]")
      ?.addEventListener("click", () => knop?.click());
    const anker = sectie.querySelector("[data-koopanker]");
    if (anker) {
      const kijker = new IntersectionObserver(
        (items) =>
          items.forEach((item) => {
            const toonBalk =
              !item.isIntersecting && item.boundingClientRect.top < 0;
            balk.classList.toggle("is-zichtbaar", toonBalk);
            balk.setAttribute("aria-hidden", String(!toonBalk));
          }),
        { threshold: 0 }
      );
      kijker.observe(anker);
    }
  }

  zetAantal(1);
  toon();
}

/* --------------------------------------------------------------------------
   Aanbevolen producten
   Dawns patroon: de sectie haalt zichzelf opnieuw op via de
   recommendations-URL (Liquid rendert de kaarten server-side) en wisselt de
   binnenkant om. Geen aanbevelingen: de sectie verdwijnt geruisloos.
   -------------------------------------------------------------------------- */

function initAanbevolen(wortel = document) {
  // Meerdere rijen op één pagina (bijvoorbeeld "past hierbij" én "meer uit
  // de winkel"), dus alle secties langs in plaats van alleen de eerste.
  wortel.querySelectorAll?.("[data-aanbevolen]").forEach(haalAanbevolen);
}

function haalAanbevolen(sectie) {
  if (!sectie || sectie.dataset.geladen || !OP_SHOPIFY) return;
  sectie.dataset.geladen = "1";

  fetch(sectie.dataset.url)
    .then((res) => (res.ok ? res.text() : Promise.reject()))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const vers = doc.querySelector("[data-aanbevolen]");
      if (!vers || !vers.querySelector(".productkaart")) {
        sectie.remove();
        return;
      }
      sectie.innerHTML = vers.innerHTML;
      initPilHover(sectie);
    })
    .catch(() => sectie.remove());
}

/* --------------------------------------------------------------------------
   Productgalerij
   Meerdere productfoto's: de duimpjes onder het grote beeld wisselen het
   hoofdbeeld. Delegatie op de galerij zelf, zodat een herrender door de
   thema-editor geen dode knoppen achterlaat.
   -------------------------------------------------------------------------- */

function initProductGalerij(wortel = document) {
  const slider = wortel.querySelector?.("[data-prodslider]");
  if (!slider || slider.dataset.sliderInit) return;
  slider.dataset.sliderInit = "1";

  const baan = slider.querySelector("[data-prodbaan]");
  const dias = [...slider.querySelectorAll(".prodslider__dia")];
  const bollen = [...slider.querySelectorAll("[data-prodbol]")];
  const vorige = slider.querySelector("[data-prodvorige]");
  const volgende = slider.querySelector("[data-prodvolgende]");
  if (!baan || dias.length < 2) return;

  // Welke dia staat er in beeld? Rekenen met de plek van de dia zelf en niet
  // met de baanbreedte: bij een foto die nog moet laden klopt die breedte nog
  // niet en landde de baan op de verkeerde dia.
  const huidige = () => {
    let dichtst = 0;
    let kleinste = Infinity;
    dias.forEach((dia, i) => {
      const afstand = Math.abs(dia.offsetLeft - baan.scrollLeft);
      if (afstand < kleinste) {
        kleinste = afstand;
        dichtst = i;
      }
    });
    return dichtst;
  };

  // Bolletjes en pijlen bij een stand zetten. Wordt zowel vanuit een klik
  // aangeroepen (meteen, niet wachten tot het schuiven klaar is) als vanuit
  // de baan zelf, zodat vegen en het toetsenbord ook kloppen.
  const zetStand = (nu) => {
    bollen.forEach((bol, i) => bol.classList.toggle("is-nu", i === nu));
    if (vorige) vorige.disabled = nu === 0;
    if (volgende) volgende.disabled = nu === dias.length - 1;
  };

  const bijwerken = () => zetStand(huidige());

  const naar = (index, { zacht = true } = {}) => {
    const doel = Math.max(0, Math.min(dias.length - 1, index));
    const plek = dias[doel].offsetLeft;
    baan.scrollTo({ left: plek, behavior: zacht ? "smooth" : "auto" });

    // Een sprong zonder animatie kan verloren gaan terwijl de baan nog aan het
    // snappen is; in het volgende frame zetten we hem dan alsnog goed.
    if (!zacht) {
      requestAnimationFrame(() => {
        if (Math.abs(baan.scrollLeft - plek) > 4) baan.scrollLeft = plek;
      });
    }

    zetStand(doel);
  };

  let wacht;
  baan.addEventListener(
    "scroll",
    () => {
      clearTimeout(wacht);
      wacht = setTimeout(bijwerken, 60);
    },
    { passive: true }
  );

  vorige?.addEventListener("click", () => naar(huidige() - 1));
  volgende?.addEventListener("click", () => naar(huidige() + 1));
  bollen.forEach((bol) =>
    bol.addEventListener("click", () => naar(Number(bol.dataset.prodbol)))
  );

  window.addEventListener("resize", bijwerken);
  bijwerken();

  /* --- De galerij volgt de gekozen variant -------------------------------
     Elke dia weet bij welk medium hij hoort en elke variant weet welk medium
     zijn foto is; zo landt een link met ?variant= meteen op de juiste kleur en
     springt de baan mee zodra je een andere kleur kiest. */
  const koopblok = document.querySelector("[data-koopblok]");
  let productdata = null;
  try {
    productdata = JSON.parse(
      koopblok?.querySelector("[data-product-json]")?.textContent || "null"
    );
  } catch {
    /* kapotte JSON: dan blijft de baan gewoon bij foto één */
  }

  const naarVariant = ({ zacht = true } = {}) => {
    const id = koopblok?.querySelector("[data-variant-id]")?.value;
    const variant = productdata?.varianten?.find(
      (v) => String(v.id) === String(id)
    );
    const media = variant?.media_id;
    if (!media) return;
    // Altijd zetten, ook als de baan er al staat: dan lopen de bolletjes
    // gegarandeerd mee met de gekozen kleur.
    const index = dias.findIndex((dia) => dia.dataset.media === String(media));
    if (index >= 0) naar(index, { zacht });
  };

  slider
    .closest("section")
    ?.addEventListener("change", () => setTimeout(naarVariant, 0));

  // Bij het laden zonder animatie: je komt binnen op de juiste foto. Twee keer,
  // want zolang de foto's nog laden verschuift de baan en snapt hij terug naar
  // de eerste dia; na window.load staat alles stil.
  naarVariant({ zacht: false });
  window.addEventListener("load", () => naarVariant({ zacht: false }), {
    once: true,
  });
}

/* --------------------------------------------------------------------------
   Reviews
   De rij schuift per kaart op: de actieve kaart staat in het midden, de buren
   steken links en rechts uit beeld. De verschuiving zit op één custom
   property (--i) op de rij; de CSS rekent het om naar hele stappen, zodat de
   kaartbreedte op één plek staat.

   Slepen kan hier later bij op dezelfde manier. De kaarten zelf komen uit
   de blokken van de sectie, dus deze lus hoeft alleen te schuiven.
   -------------------------------------------------------------------------- */

function initReviews(wortel = document) {
  const slider = wortel.querySelector("[data-reviews]");
  if (!slider || slider.dataset.reviewsInit) return;

  const rij = slider.querySelector("[data-rij]");
  const cellen = rij ? [...rij.querySelectorAll(".reviews__cel")] : [];
  if (!rij || cellen.length === 0) return;
  slider.dataset.reviewsInit = "1";

  const vorige = slider.querySelector("[data-vorige]");
  const volgende = slider.querySelector("[data-volgende]");
  let i = 0;

  // Afstand tussen twee kaarten, inclusief goot. Uitmeten in plaats van
  // narekenen: de kaartbreedte staat in een clamp() en de goot schaalt mee.
  // Meten met getBoundingClientRect en niet met offsetLeft: die rondt af op
  // hele pixels, en over zes stappen loopt de rij dan zichtbaar scheef. Beide
  // kaarten staan onder dezelfde verschuiving, dus het verschil klopt altijd.
  const stap = () =>
    cellen.length > 1
      ? cellen[1].getBoundingClientRect().left -
        cellen[0].getBoundingClientRect().left
      : cellen[0].getBoundingClientRect().width;

  const toon = () => {
    rij.style.transform = `translate3d(${-i * stap()}px, 0, 0)`;
    if (vorige) vorige.disabled = i === 0;
    if (volgende) volgende.disabled = i === cellen.length - 1;

    cellen.forEach((cel, index) => cel.classList.toggle("is-actief", index === i));
  };

  vorige?.addEventListener("click", () => {
    i = Math.max(0, i - 1);
    toon();
  });

  volgende?.addEventListener("click", () => {
    i = Math.min(cellen.length - 1, i + 1);
    toon();
  });

  // Bij een andere schermbreedte verandert de stap; even zonder overgang,
  // anders schuift de rij zichtbaar mee tijdens het slepen van het venster.
  window.addEventListener("resize", () => {
    rij.style.transition = "none";
    toon();
    requestAnimationFrame(() => (rij.style.transition = ""));
  });

  toon();
  initReviewsBeeld(wortel);
}

// Sfeerfoto schuift traag mee met de scroll; 1,05x opgeschaald in de CSS,
// dus er komt nooit een rand in beeld.
function initReviewsBeeld(wortel = document) {
  const foto = wortel.querySelector("[data-reviews-parallax]");
  const sectie = foto?.closest(".reviews");
  if (!foto || !sectie || rustigeVoorkeur.matches) return;

  let bezig = false;

  const teken = () => {
    bezig = false;
    const rect = sectie.getBoundingClientRect();
    const totaal = rect.height + window.innerHeight;
    const voortgang = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / totaal));
    foto.style.transform = `translate3d(0, ${(voortgang - 0.5) * 4}%, 0)`;
  };

  const opScroll = () => {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(teken);
  };

  window.addEventListener("scroll", opScroll, { passive: true });
  window.addEventListener("resize", opScroll);
  teken();
}

/* --------------------------------------------------------------------------
   Vragen
   Accordeon met één open paneel tegelijk. De knop houdt aria-expanded bij;
   de opmaak hangt daaraan vast, zodat er geen tweede waarheid ontstaat.
   -------------------------------------------------------------------------- */

function initVragen(wortel = document) {
  const lijst = wortel.querySelector("[data-vragen]");
  if (!lijst) return;

  const knoppen = [...lijst.querySelectorAll(".vraag__knop")];

  knoppen.forEach((knop) => {
    const paneel = knop.nextElementSibling;

    // Het paneel is buiten de tabvolgorde zolang het dicht zit
    paneel.inert = true;

    knop.addEventListener("click", () => {
      const open = knop.getAttribute("aria-expanded") === "true";

      knoppen.forEach((andere) => {
        andere.setAttribute("aria-expanded", "false");
        andere.nextElementSibling.classList.remove("is-open");
        andere.nextElementSibling.inert = true;
      });

      if (!open) {
        knop.setAttribute("aria-expanded", "true");
        paneel.classList.add("is-open");
        paneel.inert = false;
      }
    });
  });
}

/* --------------------------------------------------------------------------
   Kop-balk
   Bovenaan de pagina staat het woordmerk vol-breed boven de knoppenrij.
   Bij het scrollen wordt de balk vast en krimpt het logo naar het midden
   van de rij; de middelste menulinks faden uit om plaats te maken. Alles
   is aan de scrollpositie gekoppeld, met een lichte demping.
   -------------------------------------------------------------------------- */

let kopBalkStop = null;

function initKopBalk() {
  const balk = document.querySelector(".kop-balk");
  if (!balk || rustigeVoorkeur.matches) return;

  // De thema-editor tekent de sectie opnieuw; de vorige meetlus zou dan op
  // dode elementen blijven draaien. Eerst netjes stoppen, dan opnieuw.
  if (kopBalkStop) kopBalkStop();

  const logo = balk.querySelector(".kop-balk__logo");
  const rij = balk.querySelector(".kop-balk__binnen");
  const midden = balk.querySelector(".hoofdmenu");
  if (!logo || !rij) return;

  // Kleine weergave (ondersteunende pagina's): dezelfde machinerie — de
  // tint-proef en het menu-open-bevriezen blijven werken — maar het doel
  // staat permanent op de gekrompen eindstand.
  const vastKlein = balk.classList.contains("kop-balk--klein");

  balk.classList.add("is-vast");

  let logoH, rijH, marge, schaalEind, schuifEind, smal;
  let actiefLus = true;
  kopBalkStop = () => {
    actiefLus = false;
    window.removeEventListener("resize", meet);
  };

  const meet = () => {
    logo.style.transform = "";
    rij.style.transform = "";
    logoH = logo.offsetHeight;
    rijH = rij.offsetHeight;
    marge = parseFloat(getComputedStyle(rij).marginTop) || 0;
    // Breedte van het gekrompen logo: 300px waar dat past. Op smalle
    // schermen past er niets tussen de menuknop en de iconen; daar fadet
    // het logo uit en schuift de rij naar de bovenrand.
    // Zelfde omslagpunt als de CSS (760px), zodat JS en opmaak nooit in een
    // verschillend regime zitten — precies in dat gat rendert de editor.
    smal = window.matchMedia("(max-width: 760px)").matches;
    const klein = Math.max(90, Math.min(300, window.innerWidth - 280));
    schaalEind = smal ? 0.85 : Math.min(1, klein / logo.offsetWidth);
    // De rij schuift omhoog tot haar midden samenvalt met het midden van
    // het gekrompen logo (dat vanuit zijn bovenrand krimpt); op smal tot
    // net onder de bovenrand van het scherm.
    schuifEind = smal
      ? -logoH - marge + 12
      : (logoH * schaalEind) / 2 - logoH - marge - rijH / 2;
  };

  // --- Content-aware tint ------------------------------------------------
  // Proeft wat er achter het logo ligt en zet data-tint op de balk: op een
  // donkere achtergrond wordt het woordmerk wit (CSS regelt de kleur).
  // Een sectie kan de tint ook afdwingen met data-kop-tint="donker|licht".

  const luminantie = (kleur) => {
    const m = (kleur || "").match(
      /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\s*\)/
    );
    if (!m) return null;
    if (m[4] !== undefined && parseFloat(m[4]) === 0) return null;
    return (0.299 * +m[1] + 0.587 * +m[2] + 0.114 * +m[3]) / 255;
  };

  // Geeft de helderheid (0 = zwart, 1 = wit) van het vlak onder dit punt.
  const helderheidOp = (x, y) => {
    for (const el of document.elementsFromPoint(x, y)) {
      if (balk.contains(el)) continue;

      // Overlays van de thema-editor (sectie-highlights e.d.) zijn geen
      // pagina-inhoud; kijk er doorheen.
      if (typeof el.className === "string" && el.className.includes("shopify")) continue;
      if (el.id && el.id.startsWith("shopify")) continue;

      const afgedwongen = el.closest?.("[data-kop-tint]");
      if (afgedwongen) {
        const t = afgedwongen.dataset.kopTint;
        if (t === "donker") return 0;
        if (t === "licht") return 1;
      }

      const cs = getComputedStyle(el);

      // Tekst op een SVG-vorm (zoals het lint) is dunne decoratie; kijk
      // door de letters heen naar het vlak eronder.
      if (el.ownerSVGElement && el.closest("text")) continue;

      // SVG-vormen (zoals de donkere band): kijk naar wat er geraakt is
      if (el.ownerSVGElement) {
        const vlak =
          cs.fill !== "none" && !cs.fill.startsWith("url") ? cs.fill : cs.stroke;
        const l = luminantie(vlak);
        if (l !== null) return l;
        continue;
      }

      const l = luminantie(cs.backgroundColor);
      if (l !== null) return l;
    }
    return 1;
  };

  // Proeft over de volle breedte van de balk, niet alleen onder het logo —
  // de knoppen links en rechts staan boven heel andere vlakken.
  const proefTint = () => {
    const lr = logo.getBoundingClientRect();
    const rr = rij.getBoundingClientRect();
    if (!lr.width || !rr.width) return;

    const punten = [
      [lr.left + lr.width * 0.5, lr.top + lr.height / 2], // logo
      [rr.left + 20, rr.top + rr.height / 2], // knoppen links
      [rr.left + rr.width * 0.5, rr.top + rr.height / 2], // menu midden
      [rr.right - 20, rr.top + rr.height / 2], // knoppen rechts
    ];

    // Tellen in plaats van middelen: zodra een flink deel van de balk boven
    // een donker vlak hangt, moet alles omslaan. Een mediaan zou een halve
    // balk boven de donkere band nog als licht bestempelen.
    const donker = punten.filter(([x, y]) => helderheidOp(x, y) < 0.5).length;
    const tint = donker >= 2 ? "donker" : "licht";
    if (balk.dataset.tint !== tint) balk.dataset.tint = tint;
  };

  let p = 0;
  let laatsteProef = 0;

  /* --- Wegschuiven bij naar beneden scrollen ----------------------------
     Onder de drempel staat de balk er altijd; daarboven verdwijnt hij zodra
     je naar beneden gaat en komt hij terug bij de eerste beweging omhoog.
     In de thema-editor blijft hij staan, anders kun je hem niet instellen. */
  let vorigeY = window.scrollY;
  const inEditor = document.documentElement.classList.contains("ontwerp-modus");

  const verbergStap = () => {
    // Uitgezet in de thema-editor (sectie Kop-balk): dan blijft hij staan.
    if (balk.dataset.verbergen === "uit") {
      balk.classList.remove("is-verstopt");
      return;
    }

    if (inEditor) return;

    const y = window.scrollY;
    const verschil = y - vorigeY;
    const drempel = (logoH || 0) + (marge || 0) + 40;

    if (y <= drempel) {
      balk.classList.remove("is-verstopt");
    } else if (verschil > 4) {
      balk.classList.add("is-verstopt");
    } else if (verschil < -4) {
      balk.classList.remove("is-verstopt");
    }

    // Kleine bewegingen (of een bounce aan het einde van de pagina) laten de
    // stand met rust; alleen een echte richting telt.
    if (Math.abs(verschil) > 4) vorigeY = y;
  };

  const stap = (nu) => {
    // Zolang het menu open staat, staat de pagina vast op het scherm en is
    // window.scrollY nul. Zonder deze rem zou de balk daardoor terugklappen
    // naar zijn begintoestand terwijl de preview een gescrolde pagina laat
    // zien. Hij bevriest dus op de stand van het moment van openen.
    //
    // Dat geldt óók tijdens het terugklappen (is-sluitend): menu-open is dan
    // al weg maar de scrollpositie is nog niet hersteld. Laat de rem daar
    // los, dan flitst eerst de volle balk in beeld en krimpt hij daarna
    // opnieuw.
    if (
      document.body.classList.contains("menu-open") ||
      (document.body.classList.contains("lade-open") &&
        document.querySelector("[data-pagina]")) ||
      document.querySelector(".pagina.is-sluitend")
    ) {
      // Met een open laag hoort de balk zichtbaar te zijn: de pagina staat
      // stil, dus er valt niets weg te scrollen.
      balk.classList.remove("is-verstopt");
      vorigeY = window.scrollY;
      requestAnimationFrame(stap);
      return;
    }

    if (!actiefLus) return;

    // Sectie door de editor vervangen: deze lus is afgelost
    if (!balk.isConnected) {
      actiefLus = false;
      return;
    }

    // In de thema-editor kan de eerste meting op een nog onzichtbare balk
    // vallen (alles nul): dan zou elke scrollpixel het logo laten krimpen.
    if (!logoH) {
      meet();
      if (!logoH) {
        requestAnimationFrame(stap);
        return;
      }
    }

    const doel = vastKlein
      ? 1
      : Math.min(1, Math.max(0, window.scrollY / (logoH + marge)));
    p += (doel - p) * 0.16;
    if (Math.abs(doel - p) < 0.001) p = doel;

    const s = 1 - p * (1 - schaalEind);
    logo.style.transform = `scale(${s})`;
    rij.style.transform = `translateY(${p * schuifEind}px)`;

    // Smal scherm: het logo maakt plaats in plaats van mee de rij in te
    // schuiven — het fadet uit en vangt geen kliks meer.
    logo.style.opacity = smal ? String(Math.max(0, 1 - p * 1.8)) : "";
    logo.style.pointerEvents = smal && p > 0.4 ? "none" : "";

    if (midden) {
      midden.style.opacity = Math.max(0, 1 - p * 1.6);
      midden.style.pointerEvents = p > 0.4 ? "none" : "";
    }

    verbergStap();

    if (nu - laatsteProef > 120) {
      laatsteProef = nu;
      proefTint();
    }

    requestAnimationFrame(stap);
  };

  meet();
  // Seed op de actuele scrollstand: een (her)init — de editor herlaadt de
  // sectie ook midden op een gescrolde pagina — mag nooit eerst vol
  // uitklappen om daarna opnieuw in te krimpen.
  p = vastKlein
    ? 1
    : Math.min(1, Math.max(0, window.scrollY / ((logoH + marge) || 1)));
  window.addEventListener("resize", meet);
  requestAnimationFrame(stap);
}

/* --------------------------------------------------------------------------
   Knop-hover
   De pil-knoppen reageren niet op kale :hover maar op een klasse die hier
   wordt gezet, met een korte nagloei bij het verlaten. Zo kan de animatie
   niet dubbel afspelen wanneer de bewegende pil heel even onder de cursor
   vandaan schuift (hover-flikker).
   -------------------------------------------------------------------------- */

/* Vangnet voor blijven hangende hover.

   De kaarten en knoppen wippen op en kantelen, en verplaatsen zich daarmee
   onder de cursor vandaan. De browser toetst pas opnieuw wat er onder de
   muis ligt zodra je hem beweegt; gebeurt die beweging elders op de pagina,
   dan komt er nooit een pointerleave en blijft de kaart groot staan.

   Daarom kijken we bij elke muisbeweging (één keer per beeldopbouw) of alles
   met .is-hover nog wel onder de cursor ligt, en ruimen we op wat dat niet
   meer is. De sierknop in een gekoppelde kaart telt mee met zijn kaart: die
   heeft geen eigen hover. */
/* Het rustvlak van een element: waar het ligt als er niets aan beweegt.
   offsetLeft en offsetTop tellen transforms niet mee, dus dit vak blijft
   staan terwijl de kaart opwipt en kantelt.

   Dat is precies wat we nodig hebben. De browser toetst zijn hover op de
   gekantelde vorm: sta je op de rand van een kaart, dan draait die onder je
   cursor vandaan, stuurt de browser een pointerleave, veert de kaart terug,
   ligt hij weer onder je cursor en begint de animatie opnieuw. Toetsen we op
   het rustvlak, dan telt alleen waar de kaart hoort te liggen. */
function rustvlak(el) {
  let x = 0;
  let y = 0;
  let n = el;
  while (n) {
    x += n.offsetLeft;
    y += n.offsetTop;
    const ouder = n.offsetParent;
    // Ligt de kaart in iets dat zelf schuift, dan telt die schuifstand mee;
    // de paginascroll zit al in pageX en pageY.
    if (ouder && ouder !== document.body && ouder !== document.documentElement) {
      x -= ouder.scrollLeft;
      y -= ouder.scrollTop;
    }
    n = ouder;
  }
  return { links: x, boven: y, rechts: x + el.offsetWidth, onder: y + el.offsetHeight };
}

function opRustvlak(el, paginaX, paginaY, marge = 2) {
  if (!el || paginaX == null || paginaY == null) return false;
  const v = rustvlak(el);
  return (
    paginaX >= v.links - marge &&
    paginaX <= v.rechts + marge &&
    paginaY >= v.boven - marge &&
    paginaY <= v.onder + marge
  );
}

function hoverVangnet() {
  if (document.body.dataset.hoverVangnet) return;
  document.body.dataset.hoverVangnet = "1";

  const raakvlakVan = (el) => {
    const blok = el.closest(".productkaart, .voetkaart, .categoriekaart");
    if (el.classList.contains("pil") && blok?.querySelector("[data-pil-koppel]")) {
      return blok;
    }
    return el;
  };

  let gepland = false;
  document.addEventListener(
    "pointermove",
    (e) => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(() => {
        gepland = false;
        document.querySelectorAll(".is-hover").forEach((el) => {
          if (!opRustvlak(raakvlakVan(el), e.pageX, e.pageY)) {
            el.classList.remove("is-hover");
          }
        });
      });
    },
    { passive: true }
  );

  // De muis het venster uit: alles los
  document.addEventListener("pointerleave", () => {
    document
      .querySelectorAll(".is-hover")
      .forEach((el) => el.classList.remove("is-hover"));
  });
}

function initPilHover(wortel = document) {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  hoverVangnet();

  wortel.querySelectorAll(".pil").forEach((pil) => {
    if (pil.dataset.hoverInit) return;
    pil.dataset.hoverInit = "1";

    let timer = null;

    pil.addEventListener("pointerenter", () => {
      clearTimeout(timer);
      pil.classList.add("is-hover");
    });

    pil.addEventListener("pointerleave", (e) => {
      // De pil groeit bij hover en schuift zo onder de cursor vandaan; die
      // leave is niet echt. Alleen loslaten als de cursor buiten het
      // rustvlak ligt.
      if (opRustvlak(pil, e.pageX, e.pageY)) return;
      clearTimeout(timer);
      // 90ms nagloei: een flikker van enkele frames breekt de animatie
      // niet meer af, echt weggaan voelt nog steeds direct.
      timer = setTimeout(() => pil.classList.remove("is-hover"), 90);
    });
  });

  // Elementen met data-hover zetten de klasse op zichzelf. Zelfde reden als
  // hierboven: een kaart die onder je cursor vandaan kantelt zou met kale
  // :hover blijven herstarten.
  wortel.querySelectorAll("[data-hover]").forEach((el) => {
    if (el.dataset.hoverInit) return;
    el.dataset.hoverInit = "1";

    let timer = null;

    el.addEventListener("pointerenter", () => {
      clearTimeout(timer);
      el.classList.add("is-hover");
    });

    el.addEventListener("pointerleave", (e) => {
      if (opRustvlak(el, e.pageX, e.pageY)) return;
      clearTimeout(timer);
      timer = setTimeout(() => el.classList.remove("is-hover"), 90);
    });
  });

  // Elementen met data-pil-koppel geven hun hover door aan het blok eromheen
  // én aan de pil die erin zit. Zo wippen de productkaart en de sierknop erin
  // samen op wanneer je ergens over de kaart gaat.
  //
  // We luisteren op het blok en niet op de kliklaag: dingen die bóven die laag
  // liggen (de kleurstalen, de snelknop) haalden anders de muis van de laag af,
  // ging de kaart terugveren, kwam de muis weer op de laag en begon de animatie
  // opnieuw — een flikkerlus waarin je niets kon aanklikken.
  wortel.querySelectorAll("[data-pil-koppel]").forEach((el) => {
    if (el.dataset.koppelInit) return;
    el.dataset.koppelInit = "1";

    const blok = el.parentElement;
    const pil = blok?.querySelector(".pil");
    if (!blok) return;

    let timer = null;

    blok.addEventListener("pointerenter", () => {
      clearTimeout(timer);
      blok.classList.add("is-hover");
      pil?.classList.add("is-hover");
    });

    blok.addEventListener("pointerleave", (e) => {
      // Dit is de lus waar het om gaat op de productkaarten: op de rand van
      // de kaart draait hij weg, komt er een leave, veert hij terug en begint
      // alles opnieuw. Sta je nog op het rustvlak, dan negeren we de leave.
      if (opRustvlak(blok, e.pageX, e.pageY)) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        blok.classList.remove("is-hover");
        pil?.classList.remove("is-hover");
      }, 90);
    });
  });
}

/* --------------------------------------------------------------------------
   Menu-overlay
   -------------------------------------------------------------------------- */

function initMenu() {
  // Het paneel leeft in de layout (er is er maar één); de knop zit in de
  // kop-balk-sectie en kan door de editor opnieuw gerenderd worden. Daarom:
  // paneel altijd via document, en de knop via delegatie — die overleeft
  // elke re-render vanzelf.
  const paneel = document.querySelector("[data-menu]");
  if (!paneel || paneel.dataset.menuInit) return;
  paneel.dataset.menuInit = "1";

  // Dicht staat het paneel buiten de tabvolgorde
  paneel.inert = true;

  const pagina = document.querySelector("[data-pagina]");
  const knopVan = () => document.querySelector("[data-menu-knop]");

  // focusTerug: alleen bij sluiten via het toetsenbord. Met de muis sluiten
  // zou de knop anders in zijn hover/focus-stand blijven hangen.
  const zet = (open, { focusTerug = false } = {}) => {
    const knop = knopVan();
    paneel.classList.toggle("is-open", open);
    paneel.inert = !open;

    // De pagina wordt vastgezet op de plek waar je stond en zakt weg; alles
    // daaromheen (inert, scroll, terugkeer) zit in paginaOpzij.
    if (open) paginaOpzij.vast("menu");

    knop?.setAttribute("aria-expanded", String(open));
    document.body.classList.toggle("menu-open", open);

    if (open) {
      // Focus naar het paneel zelf, niet naar de eerste link: die kreeg
      // anders de focusring te zien terwijl je met de muis had geopend.
      // Vanaf het paneel is die link gewoon de eerstvolgende tab-stop.
      setTimeout(() => paneel.focus({ preventScroll: true }), 400);
    } else {
      // De hover-klasse blijft anders hangen: de pil schuift onder je cursor
      // vandaan als de pagina wegzakt, dus pointerleave komt nooit.
      knop?.classList.remove("is-hover");
      if (focusTerug) knop?.focus({ preventScroll: true });
      paginaOpzij.los();
    }
  };

  // Voor de editor-choreografie: lagen sluiten bij sectie-selectie
  paneel._sluit = () => {
    if (paneel.classList.contains("is-open")) zet(false);
  };

  document.addEventListener("click", (e) => {
    const knop = e.target.closest("[data-menu-knop]");
    if (!knop) return;
    zet(knop.getAttribute("aria-expanded") !== "true");
  });

  // Sluiten gebeurt in het paneel zelf; de knop in de balk blijft "Menu"
  paneel.querySelector("[data-menu-sluit]")?.addEventListener("click", () => zet(false));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && paneel.classList.contains("is-open")) {
      zet(false, { focusTerug: true });
    }
  });

  // Een klik op een menulink sluit het paneel
  paneel.addEventListener("click", (e) => {
    if (e.target.closest("a")) zet(false);
  });

  // Schuift de pagina opzij (zie .menu--schuif), dan is die weggeschoven
  // pagina zelf ook een sluitknop — behalve de menuknop erin, want die doet
  // het al.
  pagina?.addEventListener("click", (e) => {
    if (!paneel.classList.contains("is-open")) return;
    if (e.target.closest("[data-menu-knop]")) return;
    e.preventDefault();
    zet(false);
  });
}

/* --------------------------------------------------------------------------
   Kaart-onthulling (artikelraster + CTA-kaarten)
   De kaarten onthullen zich zodra ze in beeld schuiven — het patroon van de
   betaal-sectie, maar per kaart. Kaarten die samen binnenkomen spelen als
   cascade (--wacht telt binnen de batch op); een kaart die later alleen
   binnenscrolt komt meteen. Eenmaal onthuld blijft een kaart staan, ook als
   de editor de sectie opnieuw tekent.
   -------------------------------------------------------------------------- */

function initArtikelRaster(wortel = document) {
  const kaarten = wortel.querySelectorAll?.(".artikelkaart:not(.is-zichtbaar)");
  if (!kaarten || !kaarten.length) return;

  const kijker = new IntersectionObserver(
    (items) => {
      let wacht = 0;
      items.forEach((item) => {
        if (!item.isIntersecting) return;
        item.target.style.setProperty("--wacht", wacht++);
        item.target.classList.add("is-zichtbaar");
        kijker.unobserve(item.target);
      });
    },
    { threshold: 0.12 }
  );
  kaarten.forEach((kaart) => kijker.observe(kaart));
}

/* --------------------------------------------------------------------------
   Inline producten in artikelen
   In de tekst van een blogpost kan een placeholder staan (via "HTML tonen"
   in de blogpost-editor):

     <div data-artikel-product="product-handle"></div>

   Die wordt hier gevuld met een productkaart: beeld, naam, prijs en een
   bestelknop op de cart-API — zodat een verhaal midden in de tekst kan
   verkopen. Werkt alleen op Shopify (product-JSON van de winkel); mislukt
   het ophalen, dan blijft de placeholder leeg en onzichtbaar.
   -------------------------------------------------------------------------- */

function initArtikelProducten(wortel = document) {
  const houders = wortel.querySelectorAll?.(
    "[data-artikel-product]:not([data-gevuld])"
  );
  if (!houders || !houders.length || !OP_SHOPIFY) return;

  houders.forEach(async (houder) => {
    houder.dataset.gevuld = "1";
    const handle = houder.dataset.artikelProduct?.trim();
    if (!handle) return;

    let product;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return;
      product = await res.json();
    } catch {
      return;
    }

    const variant =
      product.variants?.find((v) => v.available) || product.variants?.[0];
    if (!variant) return;

    const beeld = product.featured_image || product.images?.[0] || "";
    const kaart = document.createElement("aside");
    kaart.className = "artikelproduct";
    kaart.innerHTML = `
      <div class="artikelproduct__tekst">
        <p class="artikelproduct__kicker">Uit de winkel</p>
        <p class="artikelproduct__naam"></p>
        <p class="artikelproduct__prijs"></p>
        <button class="artikelproduct__knop" type="button"></button>
      </div>
      <div class="artikelproduct__beeldvlak"></div>`;
    kaart.querySelector(".artikelproduct__naam").textContent = product.title;
    kaart.querySelector(".artikelproduct__prijs").textContent = geld(
      variant.price ?? product.price
    );

    if (beeld) {
      const img = document.createElement("img");
      img.className = "artikelproduct__beeld";
      img.src = beeld;
      img.alt = product.title;
      img.loading = "lazy";
      kaart.querySelector(".artikelproduct__beeldvlak").appendChild(img);
    }

    const knop = kaart.querySelector(".artikelproduct__knop");
    if (variant.available) {
      knop.textContent = "Bestel nu";
      knop.addEventListener("click", (e) => {
        wagen.voegToe({
          id: variant.id,
          variantId: variant.id,
          naam: product.title,
          variant:
            variant.title && variant.title !== "Default Title"
              ? variant.title
              : "",
          prijs: variant.price ?? product.price,
          beeld,
          aantal: 1,
        });
        wagen.open(e.currentTarget);
      });
    } else {
      knop.textContent = "Uitverkocht";
      knop.disabled = true;
    }

    houder.replaceChildren(kaart);
  });
}

/* --------------------------------------------------------------------------
   Delen
   Eén knop, twee wegen: waar het toestel een deelvenster heeft gebruiken we
   dat, anders belandt de link op het klembord. De bevestiging schrijft hij in
   [data-deel-tekst] als die er is — op de productpagina staat die tekst ín de
   knop, op de leespagina ernaast.
   -------------------------------------------------------------------------- */

function initDelen(wortel = document) {
  wortel.querySelectorAll?.("[data-deel]:not([data-deel-init])").forEach((knop) => {
    knop.dataset.deelInit = "1";
    knop.addEventListener("click", async () => {
      const melding =
        knop.querySelector("[data-deel-tekst]") ||
        knop.parentElement?.querySelector("[data-deel-tekst]");
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: location.href });
          return;
        }
        await navigator.clipboard.writeText(location.href);
        if (melding) {
          const oud = melding.textContent;
          melding.textContent = "Link gekopieerd";
          setTimeout(() => (melding.textContent = oud), 2200);
        }
      } catch {
        /* deelvenster gesloten of klembord geweigerd: geen actie nodig */
      }
    });
  });
}

/* --------------------------------------------------------------------------
   Blogkatern
   Links het beeld van het verhaal waar je op staat. De beelden liggen al in
   de opmaak op elkaar; hier wisselt alleen welke zichtbaar is. Focus telt
   net zo goed als de muis, zodat het ook met het toetsenbord meeloopt.
   -------------------------------------------------------------------------- */

/* ---------------------------------------------------------------------------
   Assortiment: filters toepassen en de lade op smal

   Elke wijziging verstuurt het formulier meteen, zodat er geen knop nodig is
   (zonder JavaScript staat die er wel, zie de sectie). Lege prijsvelden zetten
   we uit vóór het versturen: anders komen ze als lege parameters in de URL.

   Op smal schuift de filterkolom als lade over de pagina; de knop in de balk
   opent hem, het kruisje, Escape en een klik op de waas sluiten hem.
   --------------------------------------------------------------------------- */
/* Metselwerk: elke kaart spant precies zoveel fijne rasterrijen als hij hoog
   is, plus de gewenste tussenruimte. Daardoor sluiten de kaarten onder elkaar
   aan in plaats van dat de langste kaart de hele rij hoog maakt.

   Herrekenen na elke afbeelding en bij een venstermaat-wijziging; zolang er
   nog niets is gerekend staat het raster gewoon in rijen (zie de CSS). */
function metselwerk(wortel = document) {
  const raster = wortel.querySelector?.("[data-metselwerk]");
  if (!raster) return;

  const rijmaat = 8;
  const tussenruimte = 20;

  const rekenen = () => {
    // Eén kolom? Dan is metselwerk zinloos en zou het alleen maar hinderen.
    const kolommen = getComputedStyle(raster).gridTemplateColumns.split(" ").length;
    if (kolommen < 2) {
      raster.removeAttribute("data-metselwerk-klaar");
      raster.dataset.metselwerk = "uit";
      raster.querySelectorAll(".productkaart").forEach((k) => {
        k.style.gridRowEnd = "";
      });
      return;
    }
    raster.style.setProperty("--rijmaat", rijmaat + "px");
    raster.dataset.metselwerk = "klaar";
    raster.querySelectorAll(".productkaart").forEach((kaart) => {
      kaart.style.gridRowEnd = "";
      const hoogte = kaart.getBoundingClientRect().height;
      const spant = Math.ceil((hoogte + tussenruimte) / rijmaat);
      kaart.style.gridRowEnd = "span " + spant;
    });
  };

  rekenen();

  raster.querySelectorAll("img").forEach((beeld) => {
    if (beeld.complete) return;
    beeld.addEventListener("load", rekenen, { once: true });
    beeld.addEventListener("error", rekenen, { once: true });
  });

  // Lettertypes schuiven de tekst nog op nadat de opmaak al stond
  document.fonts?.ready?.then(rekenen);

  let wacht;
  window.addEventListener("resize", () => {
    clearTimeout(wacht);
    wacht = setTimeout(rekenen, 150);
  });
}

function initCollectie(wortel = document) {
  const sectie =
    wortel.querySelector?.("[data-collectie]") ||
    (wortel.matches?.("[data-collectie]") ? wortel : null);
  if (!sectie || sectie.dataset.collectieInit) return;
  sectie.dataset.collectieInit = "1";
  koppelCollectie(sectie);
}

/* Alles wat aan één weergave van de collectie hangt. Staat los van de init,
   omdat we het na elke filterslag opnieuw aanroepen: de inhoud van de sectie
   wordt dan vervangen door verse HTML. */
function koppelCollectie(sectie) {
  const vorm = sectie.querySelector("[data-filterformulier]");
  const kolom = sectie.querySelector("[data-filters]");

  metselwerk(sectie);

  /* --- Filteren zonder de pagina te herladen ------------------------------
     We halen alleen deze sectie opnieuw op (section_id) en wisselen de inhoud
     om. De adresbalk gaat mee, zodat delen en terug gewoon werken. Gaat er
     iets mis, dan doen we alsnog een gewone navigatie. */
  const haal = (adres, { schuif = false } = {}) => {
    sectie.classList.add("is-bezig");
    const scheiding = adres.includes("?") ? "&" : "?";
    fetch(adres + scheiding + "section_id=" + sectie.dataset.sectieId)
      .then((antwoord) => antwoord.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nieuw = doc.querySelector("[data-collectie]");
        if (!nieuw) throw new Error("sectie niet gevonden");
        sectie.innerHTML = nieuw.innerHTML;
        history.pushState({ collectie: true }, "", adres);
        sectie.classList.remove("is-bezig");
        koppelCollectie(sectie);
        initPilHover(sectie);
        if (schuif) {
          sectie.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .catch(() => {
        window.location.href = adres;
      });
  };

  if (vorm) {
    const adresVanVorm = () => {
      const velden = new URLSearchParams();
      new FormData(vorm).forEach((waarde, naam) => {
        if (waarde !== "") velden.append(naam, waarde);
      });
      const vraag = velden.toString();
      return vorm.getAttribute("action") + (vraag ? "?" + vraag : "");
    };

    vorm.addEventListener("change", (e) => {
      e.preventDefault();
      haal(adresVanVorm());
    });

    vorm.addEventListener("submit", (e) => {
      e.preventDefault();
      haal(adresVanVorm());
    });

    // De sorteerlijst staat buiten het formulier (via form=), dus change
    // bubbelt daar niet naartoe.
    document
      .querySelectorAll("select[form='" + vorm.id + "']")
      .forEach((keuze) =>
        keuze.addEventListener("change", () => haal(adresVanVorm()))
      );
  }

  // Filterpillen, "alles wissen", de merkkeuzes en de paginering
  sectie.addEventListener("click", (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    const link = e.target.closest(
      ".filterpil, .filters__wissen, .paginatie a, a.keuze"
    );
    if (!link || !link.href) return;
    e.preventDefault();
    haal(link.href, { schuif: link.matches(".paginatie a") });
  });

  // Terug in de browser: gewoon opnieuw laden, dan klopt alles zeker
  window.addEventListener("popstate", (e) => {
    if (e.state && e.state.collectie) window.location.reload();
  });

  if (!kolom) return;

  const zet = (open) => {
    kolom.classList.toggle("is-open", open);
    document.body.classList.toggle("filters-open", open);
    if (open) kolom.querySelector("[data-filters-sluit]")?.focus();
  };

  sectie
    .querySelector("[data-filters-knop]")
    ?.addEventListener("click", () => zet(true));
  kolom
    .querySelector("[data-filters-sluit]")
    ?.addEventListener("click", () => zet(false));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && kolom.classList.contains("is-open")) zet(false);
  });

  document.addEventListener("click", (e) => {
    if (!kolom.classList.contains("is-open")) return;
    if (kolom.contains(e.target)) return;
    if (e.target.closest("[data-filters-knop]")) return;
    zet(false);
  });
}

function initBlogkatern(wortel = document) {
  const kaart = wortel.querySelector?.("[data-blogkatern]");
  if (!kaart || kaart.dataset.blogInit) return;
  kaart.dataset.blogInit = "1";

  const beelden = [...kaart.querySelectorAll("[data-blogbeeld]")];
  if (!beelden.length) return;

  const toon = (index) => {
    beelden.forEach((beeld) => {
      beeld.classList.toggle("is-actief", beeld.dataset.blogbeeld === index);
    });
  };

  kaart.querySelectorAll("[data-blogregel]").forEach((regel) => {
    const index = regel.dataset.blogregel;
    regel.addEventListener("pointerenter", () => toon(index));
    regel.addEventListener("focus", () => toon(index));
  });
}

/* --------------------------------------------------------------------------
   Over ons
   De polaroids wijken voor de muis, met dezelfde duw als de betaalcirkels —
   alleen wat rustiger, want dit zijn grote kaarten in plaats van bolletjes.
   -------------------------------------------------------------------------- */

function initOverons(wortel = document) {
  const sectie = wortel.querySelector?.(".overons");
  if (!sectie || sectie.dataset.duwInit) return;
  sectie.dataset.duwInit = "1";
  initDuwBollen(sectie, ".waaier__kaart", { bereikFactor: 0.6, impuls: 16 });
}

/* --------------------------------------------------------------------------
   Geluid van de waaier-video's
   De clips spelen zonder geluid (anders mag de browser ze niet vanzelf
   starten). Eén knop per clip zet het geluid aan, en zet het bij de andere
   clips meteen uit — twee kanalen tegelijk wil niemand.
   -------------------------------------------------------------------------- */

function initWaaierGeluid(wortel = document) {
  const knoppen = wortel.querySelectorAll?.("[data-geluid]:not([data-geluid-init])");
  if (!knoppen || !knoppen.length) return;

  const zet = (knop, aan) => {
    const video = knop.closest(".waaier__vlak")?.querySelector("video");
    if (!video) return;
    video.muted = !aan;
    if (aan) video.play?.().catch(() => {});
    knop.setAttribute("aria-pressed", String(aan));
    knop.setAttribute("aria-label", aan ? "Geluid uitzetten" : "Geluid aanzetten");
    knop
      .querySelector("use")
      ?.setAttribute("href", aan ? "#ic-geluid-aan" : "#ic-geluid-uit");
  };

  knoppen.forEach((knop) => {
    knop.dataset.geluidInit = "1";
    knop.addEventListener("click", () => {
      const aan = knop.getAttribute("aria-pressed") !== "true";
      // Eerst alles dempen, dan deze aanzetten
      document
        .querySelectorAll("[data-geluid]")
        .forEach((andere) => zet(andere, false));
      if (aan) zet(knop, true);
    });
  });
}

/* --------------------------------------------------------------------------
   Winkelwagenpagina

   De /cart-pagina praat met dezelfde cart-API als de lade. Na elke wijziging
   halen we alleen deze sectie opnieuw op (section_id) en wisselen we de
   binnenkant om: Liquid blijft de bedragen opmaken, en de teller in de balk
   en de lade lopen mee via wagen.haalOp().

   Zonder JavaScript blijft het formulier naar /cart werken; dan doet de
   knop "Bijwerken" uit de noscript hetzelfde werk.
   -------------------------------------------------------------------------- */

function initWagenPagina(wortel = document) {
  const sectie =
    wortel.querySelector?.("[data-wagenpagina]") ||
    (wortel.matches?.("[data-wagenpagina]") ? wortel : null);
  if (!sectie || sectie.dataset.wagenpaginaInit) return;
  sectie.dataset.wagenpaginaInit = "1";

  // De meldingen staan ín de sectie, en die vervangen we telkens. Daarom
  // houden we ze hier vast en zetten we ze na elke verversing terug.
  let melding = "";
  let kortingfout = "";
  let laatsteCode = "";

  const toonMeldingen = () => {
    const vak = sectie.querySelector("[data-wagenmelding]");
    if (vak) {
      vak.textContent = melding;
      vak.toggleAttribute("hidden", !melding);
    }
    const foutvak = sectie.querySelector("[data-kortingfout]");
    if (foutvak) {
      foutvak.textContent = kortingfout;
      foutvak.toggleAttribute("hidden", !kortingfout);
    }

    // Een geweigerde code laten staan; anders typ je alles opnieuw
    const veld = sectie.querySelector("[data-kortingveld]");
    if (veld && kortingfout && laatsteCode) veld.value = laatsteCode;
  };

  const ververs = async () => {
    try {
      const antwoord = await fetch(
        window.location.pathname + "?section_id=" + sectie.dataset.sectieId
      );
      const html = await antwoord.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nieuw = doc.querySelector("[data-wagenpagina]");
      if (!nieuw) throw new Error("sectie niet gevonden");
      sectie.innerHTML = nieuw.innerHTML;
      initPilHover(sectie);
    } catch {
      window.location.reload();
      return;
    }
    sectie.classList.remove("is-bezig");
    toonMeldingen();
    wagen.haalOp();
  };

  const zetAantal = async (sleutel, aantal) => {
    sectie.classList.add("is-bezig");
    melding = "";
    try {
      const antwoord = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: sleutel, quantity: Math.max(0, aantal) }),
      });
      if (!antwoord.ok) {
        melding =
          antwoord.status === 422
            ? "Hier hebben we er niet meer van op voorraad."
            : "Dit lukte niet; probeer het zo nog eens.";
      }
    } catch {
      melding = "Geen verbinding; probeer het zo nog eens.";
    }
    await ververs();
  };

  // De cart-API wil de vólledige lijst codes terug: wat je stuurt is wat de
  // wagen overhoudt. Een lege lijst haalt ze allemaal weg.
  const codesNu = () =>
    [...sectie.querySelectorAll("[data-korting-weg]")].map(
      (knop) => knop.dataset.kortingWeg
    );

  const zetKortingen = async (codes, nieuwe) => {
    sectie.classList.add("is-bezig");
    kortingfout = "";
    laatsteCode = nieuwe || "";
    try {
      const antwoord = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: codes.join(",") }),
      });
      const data = await antwoord.json().catch(() => null);
      const geweigerd = (data?.discount_codes || []).find(
        (regel) =>
          nieuwe &&
          regel.code.toLowerCase() === nieuwe.toLowerCase() &&
          !regel.applicable
      );
      if (geweigerd) kortingfout = "\u201c" + nieuwe + "\u201d geldt niet voor deze bestelling.";
    } catch {
      kortingfout = "Geen verbinding; probeer het zo nog eens.";
    }
    await ververs();
  };

  sectie.addEventListener("click", (e) => {
    const stap = e.target.closest("[data-wagen-stap]");
    const weg = e.target.closest("[data-wagen-weg]");
    const kortingWeg = e.target.closest("[data-korting-weg]");
    const rij = e.target.closest("[data-wagenrij]");

    if (stap && rij) {
      zetAantal(rij.dataset.sleutel, Number(stap.dataset.wagenStap));
      return;
    }
    if (weg && rij) {
      zetAantal(rij.dataset.sleutel, 0);
      return;
    }
    if (kortingWeg) {
      const blijft = codesNu().filter(
        (code) => code !== kortingWeg.dataset.kortingWeg
      );
      zetKortingen(blijft);
    }
  });

  sectie.addEventListener("change", (e) => {
    const veld = e.target.closest("[data-wagen-veld]");
    if (veld) {
      const rij = veld.closest("[data-wagenrij]");
      if (rij) zetAantal(rij.dataset.sleutel, Number(veld.value));
      return;
    }

    // De opmerking bewaren we zonder de pagina opnieuw te tekenen, anders
    // springt de cursor uit het veld.
    const notitie = e.target.closest("[data-wagennotitie]");
    if (notitie) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: notitie.value }),
      }).then(() => {
        const bewaard = sectie.querySelector("[data-notitie-bewaard]");
        if (!bewaard) return;
        bewaard.hidden = false;
        clearTimeout(bewaard._klok);
        bewaard._klok = setTimeout(() => (bewaard.hidden = true), 2000);
      });
    }
  });

  sectie.addEventListener("submit", (e) => {
    const vorm = e.target.closest("[data-kortingvorm]");
    if (!vorm) return;
    e.preventDefault();
    const veld = vorm.querySelector("[data-kortingveld]");
    const code = (veld?.value || "").trim();
    if (!code) return;
    zetKortingen([...codesNu(), code], code);
  });
}

/* --------------------------------------------------------------------------
   Productfoto vergroten (de loep)

   Klik op een foto in de galerij en hij komt op ware grootte over de pagina;
   met de pijltjes blader je door de rest. Escape of een klik ernaast sluit
   hem weer. Video's slaan we over: die spelen in de galerij zelf.
   -------------------------------------------------------------------------- */

function initLoep(wortel = document) {
  const galerij =
    wortel.querySelector?.("[data-galerij]") ||
    (wortel.matches?.("[data-galerij]") ? wortel : null);
  if (!galerij || galerij.dataset.loepInit) return;
  galerij.dataset.loepInit = "1";

  const fotos = () => [...galerij.querySelectorAll("img[data-loep]")];
  let laag = null;
  let nu = 0;

  const teken = () => {
    const lijst = fotos();
    const beeld = lijst[nu];
    if (!beeld || !laag) return;
    laag.querySelector("[data-loep-beeld]").src = beeld.dataset.loep;
    laag.querySelector("[data-loep-beeld]").alt = beeld.alt || "";
    laag.querySelectorAll("[data-loep-stap]").forEach((knop) => {
      knop.hidden = lijst.length < 2;
    });
  };

  const sluit = () => {
    laag?.remove();
    laag = null;
    // Eigen klasse: lade-open laat de pagina eronder wegschuiven alsof de
    // winkelwagen opengaat, en dat hoort hier niet te gebeuren.
    document.body.classList.remove("loep-open");
  };

  const open = (index) => {
    nu = index;
    laag = document.createElement("div");
    laag.className = "loep";
    laag.innerHTML = `
      <button class="loep__sluit" type="button" data-loep-sluit aria-label="Sluiten">
        <svg aria-hidden="true"><use href="#ic-kruis" /></svg>
      </button>
      <button class="loep__stap loep__stap--vorige" type="button" data-loep-stap="-1" aria-label="Vorige foto">
        <svg aria-hidden="true"><use href="#ic-pijl" /></svg>
      </button>
      <img class="loep__beeld" data-loep-beeld src="" alt="" />
      <button class="loep__stap loep__stap--volgende" type="button" data-loep-stap="1" aria-label="Volgende foto">
        <svg aria-hidden="true"><use href="#ic-pijl" /></svg>
      </button>`;
    document.body.append(laag);
    document.body.classList.add("loep-open");
    teken();

    laag.addEventListener("click", (e) => {
      const stap = e.target.closest("[data-loep-stap]");
      if (stap) {
        const lijst = fotos();
        nu = (nu + Number(stap.dataset.loepStap) + lijst.length) % lijst.length;
        teken();
        return;
      }
      // Alles buiten de foto zelf sluit
      if (!e.target.closest("[data-loep-beeld]")) sluit();
    });
  };

  galerij.addEventListener("click", (e) => {
    const beeld = e.target.closest("img[data-loep]");
    if (!beeld) return;
    open(fotos().indexOf(beeld));
  });

  document.addEventListener("keydown", (e) => {
    if (!laag) return;
    if (e.key === "Escape") sluit();
    if (e.key === "ArrowRight") laag.querySelector('[data-loep-stap="1"]')?.click();
    if (e.key === "ArrowLeft") laag.querySelector('[data-loep-stap="-1"]')?.click();
  });
}

/* --------------------------------------------------------------------------
   Cadeaubon: naar wie gaat hij?
   -------------------------------------------------------------------------- */

function initOntvanger(wortel = document) {
  const vak =
    wortel.querySelector?.("[data-ontvanger]") ||
    (wortel.matches?.("[data-ontvanger]") ? wortel : null);
  if (!vak || vak.dataset.ontvangerInit) return;
  vak.dataset.ontvangerInit = "1";

  const aan = vak.querySelector("[data-ontvanger-aan]");
  const velden = vak.querySelector("[data-ontvanger-velden]");

  const bij = () => {
    velden.hidden = !aan.checked;
    // Verborgen velden mogen niet meesturen: dan klaagt Shopify over een
    // leeg e-mailadres terwijl je de bon voor jezelf koopt.
    velden.querySelectorAll("input, textarea").forEach((veld) => {
      veld.disabled = !aan.checked;
    });
  };

  aan.addEventListener("change", bij);
  bij();
}

/* --------------------------------------------------------------------------
   Ophalen in de winkel

   Per variant kan de beschikbaarheid verschillen, dus halen we het blokje
   opnieuw op zodra je een andere kiest. Staat afhalen uit in Shopify, dan
   komt er niets terug en blijft het stil.
   -------------------------------------------------------------------------- */

function initOphalen(wortel = document) {
  const vak =
    wortel.querySelector?.("[data-ophalen]") ||
    (wortel.matches?.("[data-ophalen]") ? wortel : null);
  if (!vak || vak.dataset.ophalenInit) return;
  vak.dataset.ophalenInit = "1";

  const vorm = vak.closest("form") || document.querySelector(".uitgelicht__vorm");
  if (!vorm) return;

  const haal = () => {
    const id = vorm.querySelector("[data-variant-id]")?.value;
    if (!id) return;
    fetch(vak.dataset.url + id)
      .then((antwoord) => antwoord.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        vak.innerHTML = doc.querySelector(".shopify-section")?.innerHTML || "";
      })
      .catch(() => {
        /* niets: het blokje blijft staan zoals het stond */
      });
  };

  vorm.addEventListener("change", () => setTimeout(haal, 0));
}

/* --------------------------------------------------------------------------
   Recent bekeken

   De ids staan in de browser zelf. Op een productpagina zetten we het huidige
   product vooraan; op elke pagina met de sectie halen we de kaarten op via de
   zoekroute (id:123 OR id:456), zodat Liquid ze tekent.
   -------------------------------------------------------------------------- */

const RECENT_SLEUTEL = "liefs-recent";

function onthoudProduct(wortel = document) {
  const sectie = wortel.querySelector?.("[data-product-id]");
  const id = sectie?.dataset.productId;
  if (!id) return;

  try {
    const lijst = JSON.parse(localStorage.getItem(RECENT_SLEUTEL) || "[]");
    const nieuw = [id, ...lijst.filter((x) => String(x) !== String(id))].slice(0, 12);
    localStorage.setItem(RECENT_SLEUTEL, JSON.stringify(nieuw));
  } catch {
    /* privémodus: dan onthouden we niets */
  }
}

function initRecent(wortel = document) {
  const sectie =
    wortel.querySelector?.("[data-recent]") ||
    (wortel.matches?.("[data-recent]") ? wortel : null);
  if (!sectie || sectie.dataset.recentInit) return;
  sectie.dataset.recentInit = "1";

  let lijst = [];
  try {
    lijst = JSON.parse(localStorage.getItem(RECENT_SLEUTEL) || "[]");
  } catch {
    return;
  }

  // Het product waar je nu op staat hoort er niet bij
  const hier = document.querySelector("[data-product-id]")?.dataset.productId;
  const ids = lijst
    .filter((id) => String(id) !== String(hier))
    .slice(0, Number(sectie.dataset.aantal) || 4);
  if (ids.length === 0) return;

  const vraag = ids.map((id) => "id:" + id).join(" OR ");
  fetch(sectie.dataset.url + encodeURIComponent(vraag))
    .then((antwoord) => antwoord.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nieuw = doc.querySelector("[data-recent]");
      if (nieuw) sectie.innerHTML = nieuw.innerHTML;
      initPilHover(sectie);
      initKaartraster(sectie);
    })
    .catch(() => {
      /* niets gevonden: de sectie blijft leeg en dus onzichtbaar */
    });
}

/* --------------------------------------------------------------------------
   Snel toevoegen vanaf een kaart

   Producten met één variant gaan met één tik in de winkelwagen; de lade komt
   niet open, de knop bevestigt zelf even en de teller in de balk telt mee.
   Zijn er keuzes te maken, dan is de knop een link naar het product en komt
   deze code er niet aan te pas.
   -------------------------------------------------------------------------- */


/* --------------------------------------------------------------------------
   Kleurstalen op een kaart

   Wijs een staal aan en de foto van de kaart springt naar die kleur; haal je
   de muis weg, dan komt de oorspronkelijke foto terug.
   -------------------------------------------------------------------------- */

function initStalen(wortel = document) {
  const doel = wortel === document ? document.body : wortel;
  if (!doel || doel.dataset?.stalenInit) return;
  if (doel.dataset) doel.dataset.stalenInit = "1";

  const wissel = (staal, terug) => {
    const kaart = staal.closest(".productkaart");
    const beeld = kaart?.querySelector(".productkaart__beeld");
    const nieuw = staal.dataset.staal;
    if (!beeld || !nieuw) return;

    if (terug) {
      if (beeld.dataset.oorspronkelijk) {
        beeld.src = beeld.dataset.oorspronkelijk;
        beeld.removeAttribute("srcset");
      }
      return;
    }

    if (!beeld.dataset.oorspronkelijk) beeld.dataset.oorspronkelijk = beeld.src;
    beeld.removeAttribute("srcset");
    beeld.src = nieuw;
  };

  doel.addEventListener("pointerover", (e) => {
    const staal = e.target.closest("[data-staal]");
    if (staal) wissel(staal, false);
  });

  doel.addEventListener("pointerout", (e) => {
    const staal = e.target.closest("[data-staal]");
    if (staal) wissel(staal, true);
  });
}

/* --------------------------------------------------------------------------
   Pop-up

   Komt na een paar seconden binnen en blijft daarna weg zolang de bezoeker
   dat wil: het wegklikken onthouden we in de browser zelf, met een datum
   erbij zodat hij na de ingestelde periode weer mag verschijnen.
   -------------------------------------------------------------------------- */

function initPopup(wortel = document) {
  const popup =
    wortel.querySelector?.("[data-popup]") ||
    (wortel.matches?.("[data-popup]") ? wortel : null);
  if (!popup || popup.dataset.popupInit) return;
  popup.dataset.popupInit = "1";

  const sleutel = popup.dataset.sleutel;
  const dagen = Number(popup.dataset.dagen) || 14;

  const magNiet = () => {
    try {
      const tot = Number(localStorage.getItem(sleutel) || 0);
      return tot > Date.now();
    } catch {
      return false;
    }
  };

  const sluit = () => {
    popup.classList.remove("is-open");
    try {
      localStorage.setItem(sleutel, String(Date.now() + dagen * 864e5));
    } catch {
      /* privémodus: dan komt hij een volgende keer weer */
    }
    setTimeout(() => (popup.hidden = true), 450);
  };

  // In de thema-editor altijd meteen laten zien, anders kun je hem niet
  // instellen zonder te wachten.
  const inEditor = document.documentElement.classList.contains("ontwerp-modus");
  if (magNiet() && !inEditor) return;

  const wacht = inEditor ? 0 : (Number(popup.dataset.vertraging) || 6) * 1000;
  setTimeout(() => {
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add("is-open"));
  }, wacht);

  popup.querySelector("[data-popup-sluit]")?.addEventListener("click", sluit);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popup.classList.contains("is-open")) sluit();
  });

  // Na een geslaagde aanmelding hoeft hij ook niet meer terug te komen
  if (popup.querySelector(".popup__gelukt")) {
    try {
      localStorage.setItem(sleutel, String(Date.now() + dagen * 864e5));
    } catch {
      /* niets */
    }
  }
}

/* --------------------------------------------------------------------------
   Kopieerbare gegevens

   Een regel met een KvK- of btw-nummer is een knop: tikken zet de waarde op
   het klembord en de knop zegt het even terug. Zonder klembord-toegang (oude
   browser, geen https) selecteren we de tekst, dan kun je hem alsnog pakken.
   -------------------------------------------------------------------------- */

function initKopieer(wortel = document) {
  const doel = wortel === document ? document.body : wortel;
  if (!doel || doel.dataset?.kopieerInit) return;
  if (doel.dataset) doel.dataset.kopieerInit = "1";

  doel.addEventListener("click", async (e) => {
    const knop = e.target.closest("[data-kopieer]");
    if (!knop) return;

    const waarde = knop.dataset.kopieer;
    const hint = knop.querySelector(".gegeven__hint");
    let gelukt = false;

    try {
      await navigator.clipboard.writeText(waarde);
      gelukt = true;
    } catch {
      // Geen toegang tot het klembord: dan de tekst selecteren, zodat je hem
      // met de gewone kopieersneltoets alsnog meeneemt.
      const veld = knop.querySelector(".gegeven__waarde");
      if (veld) {
        const bereik = document.createRange();
        bereik.selectNodeContents(veld);
        const selectie = window.getSelection();
        selectie?.removeAllRanges();
        selectie?.addRange(bereik);
      }
    }

    if (hint) hint.textContent = gelukt ? "Gekopieerd" : "Selecteer";
    knop.classList.add("is-gekopieerd");
    clearTimeout(knop._kopieerKlok);
    knop._kopieerKlok = setTimeout(() => {
      knop.classList.remove("is-gekopieerd");
      if (hint) hint.textContent = "Kopieer";
    }, 1800);
  });
}

/* --------------------------------------------------------------------------
   Beleidspagina's opruimen

   Shopify levert de voorwaarden, het privacybeleid en de rest als één lange
   lap tekst in een vaste opbouw. Die knippen we hier in stukken bij de
   kopjes: links een inhoudsopgave die meeplakt, rechts uitklappers per
   onderdeel — dezelfde uitklapper als bij de veelgestelde vragen.

   De kopjes komen in twee smaken: echte koppen (h2/h3) in het privacybeleid,
   en vetgedrukte regels binnen één alinea in de voorwaarden. Allebei worden
   herkend; vindt hij niets, dan blijft de tekst gewoon zoals hij was.
   -------------------------------------------------------------------------- */

/* De hoogte van de gekrompen kop-balk in pixels. Het thema bewaart die als
   CSS-variabele met een calc erin; een onzichtbaar hulpelementje laat de
   browser hem uitrekenen. */
function kopHoogte() {
  const proef = document.createElement("div");
  proef.style.cssText =
    "position:absolute;top:0;left:0;visibility:hidden;pointer-events:none;height:var(--kop-klein-hoogte)";
  document.body.append(proef);
  const hoogte = proef.offsetHeight || 96;
  proef.remove();
  return hoogte;
}

function initBeleid(wortel = document) {
  const lijf =
    wortel.querySelector?.(".shopify-policy__body .rte") ||
    wortel.querySelector?.(".shopify-policy__body");
  if (!lijf || lijf.dataset.beleidInit) return;
  lijf.dataset.beleidInit = "1";

  // Het privacybeleid zit in één omhullende <div>; daar kijken we doorheen.
  // De voorwaarden zijn juist één lange <p> met alles erin: die moeten we
  // wél als kind behandelen, anders vindt de knipper geen kopjes.
  const enigKind = lijf.children.length === 1 ? lijf.firstElementChild : null;
  const bron =
    enigKind && /^(DIV|SECTION|ARTICLE)$/.test(enigKind.tagName) ? enigKind : lijf;

  /* --- 0. Rij met de andere voorwaarden onder de titel ------------------ */

  const titelvak = document.querySelector(".shopify-policy__title");
  const bron_menu = document.querySelector("[data-beleidmenu]");
  if (titelvak && bron_menu && !titelvak.querySelector(".beleidlinks")) {
    let lijst = [];
    try {
      lijst = JSON.parse(bron_menu.textContent) || [];
    } catch {
      lijst = [];
    }

    // Alles behalve de pagina waar je nu op staat
    const hier = window.location.pathname;
    const anderen = lijst.filter((item) => {
      try {
        return new URL(item.url, window.location.origin).pathname !== hier;
      } catch {
        return true;
      }
    });

    if (anderen.length) {
      const rij = document.createElement("div");
      rij.className = "beleidlinks";
      anderen.forEach((item, i) => {
        const kaart = document.createElement("a");
        kaart.className = "categoriekaart beleidlink";
        kaart.href = item.url;
        kaart.style.setProperty("--i", String(i));
        const tekst = document.createElement("span");
        tekst.className = "categoriekaart__tekst";
        tekst.textContent = item.titel;
        kaart.append(tekst);
        rij.append(kaart);
      });
      titelvak.append(rij);
    }
  }

  /* --- 1. In stukken knippen ------------------------------------------- */

  const stukken = [];
  const nieuwStuk = (titel) => stukken.push({ titel, knopen: [] });
  const bewaar = (knoop) => {
    if (!stukken.length) nieuwStuk(null);
    stukken[stukken.length - 1].knopen.push(knoop);
  };
  const heeftTekst = (el) => el.textContent.replace(/\s+/g, "").length > 0;

  // Een vetgedrukt stukje is een kopje als het vooraan een regel staat, kort
  // is en niet als zin eindigt.
  const isKopje = (el, vorige) => {
    if (!el || el.nodeType !== 1 || el.tagName !== "STRONG") return false;
    const tekst = el.textContent.trim();
    if (tekst.length < 3 || tekst.length > 90) return false;
    if (/[.,;:]$/.test(tekst)) return false;
    if (!vorige) return true;
    if (vorige.nodeType === 1 && vorige.tagName === "BR") return true;
    return vorige.nodeType === 3 && vorige.textContent.trim() === "";
  };

  [...bron.childNodes].forEach((kind) => {
    if (kind.nodeType === 1 && /^H[1-4]$/.test(kind.tagName)) {
      nieuwStuk(kind.textContent.trim());
      return;
    }

    if (kind.nodeType === 1 && kind.tagName === "P" && kind.querySelector("strong")) {
      let alinea = document.createElement("p");
      let vorige = null;

      [...kind.childNodes].forEach((deel) => {
        if (isKopje(deel, vorige)) {
          if (heeftTekst(alinea)) bewaar(alinea);
          alinea = document.createElement("p");
          nieuwStuk(deel.textContent.trim());
        } else if (!(deel.nodeType === 1 && deel.tagName === "BR" && !heeftTekst(alinea))) {
          alinea.append(deel.cloneNode(true));
        }
        vorige = deel;
      });

      if (heeftTekst(alinea)) bewaar(alinea);
      return;
    }

    bewaar(kind.cloneNode(true));
  });

  const metTitel = stukken.filter((stuk) => stuk.titel);
  if (metTitel.length < 3) return; // te weinig om op te delen

  /* --- 2. Opnieuw opbouwen --------------------------------------------- */

  const houder = document.createElement("div");
  houder.className = "beleid__lijf";

  const zij = document.createElement("nav");
  zij.className = "beleid__zij";
  zij.setAttribute("aria-label", "Inhoud van deze pagina");
  zij.innerHTML = '<p class="beleid__zij-kop subkop">Op deze pagina</p>';

  const tekst = document.createElement("div");
  tekst.className = "beleid__tekst";
  tekst.dataset.vragen = "";

  stukken.forEach((stuk, i) => {
    if (!stuk.titel) {
      // Inleiding zonder kopje: gewoon leesbaar bovenaan
      if (!stuk.knopen.some(heeftTekst)) return;
      const intro = document.createElement("div");
      intro.className = "beleid__intro rijketekst";
      stuk.knopen.forEach((k) => intro.append(k));
      tekst.append(intro);
      return;
    }

    const id = "beleid-" + i;
    const vraag = document.createElement("div");
    vraag.className = "vraag";
    vraag.id = id;

    const knop = document.createElement("button");
    knop.className = "vraag__knop";
    knop.type = "button";
    knop.setAttribute("aria-expanded", "false");
    knop.innerHTML =
      "<span></span><span class=\"vraag__teken\" aria-hidden=\"true\"></span>";
    knop.firstElementChild.textContent = stuk.titel;

    const paneel = document.createElement("div");
    paneel.className = "vraag__paneel";
    const inhoud = document.createElement("div");
    inhoud.className = "vraag__lijf rijketekst";
    stuk.knopen.forEach((k) => inhoud.append(k));
    paneel.append(inhoud);

    vraag.append(knop, paneel);
    tekst.append(vraag);

    const stap = document.createElement("button");
    stap.className = "beleid__stap";
    stap.type = "button";
    stap.textContent = stuk.titel;

    stap.addEventListener("click", () => {
      const moetOpen = knop.getAttribute("aria-expanded") !== "true";
      if (moetOpen) knop.click();

      // Pas schuiven als het open- en dichtklappen klaar is: er gaat er ook
      // eentje dicht, en daardoor schuift alles boven het doel omhoog. En met
      // de ruimte van de kop-balk erbij, anders valt de titel eronder.
      const schuif = () => {
        const doel =
          vraag.getBoundingClientRect().top + window.scrollY - kopHoogte() - 10;
        window.scrollTo({ top: Math.max(0, doel), behavior: "smooth" });
      };

      if (moetOpen) setTimeout(schuif, 380);
      else schuif();
    });

    zij.append(stap);

    // De inhoudsopgave laat zien welk onderdeel openstaat
    knop.addEventListener("click", () => {
      // Even wachten tot de uitklapper zijn eigen klik heeft afgehandeld;
      // setTimeout en geen animatieframe, zodat het ook werkt in een tabblad
      // dat op de achtergrond staat.
      setTimeout(() => {
        const open = knop.getAttribute("aria-expanded") === "true";
        zij.querySelectorAll(".beleid__stap").forEach((s) => s.classList.remove("is-nu"));
        if (open) stap.classList.add("is-nu");
      }, 0);
    });
  });

  houder.append(zij, tekst);
  lijf.replaceChildren(houder);

  // Eén uitklapper tegelijk open, net als bij de veelgestelde vragen.
  // initVragen zoekt [data-vragen] ín wat je meegeeft, dus de houder eromheen.
  initVragen(houder);
}

/* --------------------------------------------------------------------------
   Productenrij op de homepagina

   De kaarten komen uit Liquid; hier wordt alleen het metselwerk gelegd, de
   hover gekoppeld en — als er een einddatum staat — de klok gestart.
   -------------------------------------------------------------------------- */

function initProducten(wortel = document) {
  const sectie =
    wortel.querySelector?.("[data-producten]") ||
    (wortel.matches?.("[data-producten]") ? wortel : null);
  if (!sectie || sectie.dataset.productenInit) return;
  sectie.dataset.productenInit = "1";

  metselwerk(sectie);
  initPilHover(sectie);
  initAftellen(sectie);

  window.addEventListener("resize", () => metselwerk(sectie));
}

/* --------------------------------------------------------------------------
   Alle lagen dicht
   Voor de thema-editor (editor.js): bij sectie-selectie scrolt de editor de
   preview zelf, en dan mag er geen laag openstaan die de pagina vastzet.
   Elke sluit is een no-op als de laag al dicht is.
   -------------------------------------------------------------------------- */

function sluitAlleLagen() {
  wagen.sluit();
  zoeklaag.sluit();
  accountlaag.sluit();
  document.querySelector("[data-menu]")?._sluit?.();
}

/* --------------------------------------------------------------------------
   Start
   -------------------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {
  // Altijd, los van welke secties er staan: niets met .opkomer mag ooit op
  // opacity 0 blijven hangen (ook niet als de merchant de hero of cover in
  // de editor weghaalt).
  startOnthulling();

  initHero();
  initKopBalk();
  initBetaal();
  initCarrousel();
  initKaartraster();
  initActie();
  initWinkelwagen();
  initZoeken();
  initAccount();
  initBewaren();
  initKoopblok();
  initProductGalerij();
  initAanbevolen();
  initReviews();
  initVragen();
  initArtikelRaster();
  initArtikelProducten();
  initDelen();
  initWaaierGeluid();
  initOverons();
  initBlogkatern();
  initCollectie();
  initWagenPagina();
  initLoep();
  initStalen();
  initKopieer();
  initBeleid();
  initProducten();
  initPopup();
  initOntvanger();
  initOphalen();
  onthoudProduct();
  initRecent();
  initMenu();
  initPilHover();
});

// Zodat secties in de Shopify theme editor opnieuw initialiseren
document.addEventListener("shopify:section:load", (e) => {
  initHero(e.target);
  initBetaal(e.target);
  initCarrousel(e.target);
  initKaartraster(e.target);
  initActie(e.target);
  initWinkelwagen(e.target);
  initZoeken(e.target);
  initAccount(e.target);
  initKoopblok(e.target);
  initProductGalerij(e.target);
  initAanbevolen(e.target);
  initReviews(e.target);
  initVragen(e.target);
  initArtikelRaster(e.target);
  initArtikelProducten(e.target);
  initDelen(e.target);
  initWaaierGeluid(e.target);
  initOverons(e.target);
  initBlogkatern(e.target);
  initCollectie(e.target);
  initProducten(e.target);
  initWagenPagina(e.target);
  initLoep(e.target);
  initPopup(e.target);
  initOntvanger(e.target);
  initOphalen(e.target);
  initRecent(e.target);
  initMenu(e.target);
  initPilHover(e.target);
  // Alleen als de kop-balk-sectie zélf herlaadde (de init lost de oude lus af)
  if (e.target.querySelector?.(".kop-balk")) initKopBalk();
});
